/* eyebuddy-rx-flow.js — EyeBuddy lens wizard.
   Public flow: Single Vision / Multifocal / Non-Prescription / Frame Only. */
(function () {
  'use strict';

  var root = document.querySelector('[data-eb-rxflow]');
  if (!root || root.dataset.ebInit) return;
  root.dataset.ebInit = '1';

  var CFG;
  try {
    CFG = JSON.parse(root.querySelector('[data-eb-rxflow-config]').textContent);
  } catch (e) {
    console.error('[eb-rxflow] bad config JSON', e);
    return;
  }

  var $ = function (sel) { return root.querySelector(sel); };
  var money = function (n) { return '$' + Number(n || 0).toFixed(2) + ' USD'; };
  var fmtP = function (v) { var n = parseFloat(v) || 0; return (n > 0 ? '+' : '') + n.toFixed(2); };
  var fmtRange = function (min, max, plusFirst) {
    if (Math.abs(min) === Math.abs(max)) {
      return plusFirst ? fmtP(min) + ' to ' + fmtP(max) : 'up to \u00b1' + Math.abs(Number(max || 0)).toFixed(2);
    }
    return fmtP(min) + ' to ' + fmtP(max);
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  function toast(msg) {
    var t = $('[data-eb-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('eb-toast--show');
    setTimeout(function () { t.classList.remove('eb-toast--show'); }, 2200);
  }

  var V = {
    blue: 56173391446308,
    photo: 56173380075812,
    classic: 56173380174116,
    gradient: 56173380272420,
    polarized: 56173380305188,
    mirrored: 56173380370724,
    hi161: 56173873135908,
    hi167: 56173392298276,
    hi174: 56173380436260,
    pcStd: 56173378339108,
    pcHigh: 56173378568484,
    pcUltra: 56173379092772,
    trivexStd: 56173380796708,
    trivexAdv: 56173380960548,
    progressive: 56173380993316,
    bifocal: 56173381091620
  };

  var IMG = {
    clear: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-clear-clear_160x160.png?v=1788067862',
    blue: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-blue-light-blue-light_160x160.png?v=1788067696',
    photo: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-photochromic-Photochromic-grey_160x160.gif?v=1788067699',
    classic: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-classic-tint-Classic_Tint-brown_160x160.png?v=1788068324',
    classicGray: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-classic-tint-Classic_Tint-gery_160x160.png?v=1788068324',
    classicBrown: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-classic-tint-Classic_Tint-brown_160x160.png?v=1788068324',
    classicGreen: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-classic-tint-Classic_Tint-green_160x160.png?v=1788068324',
    gradient: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-gradient-tint-Gradient_Tint-blue_160x160.png?v=1788067718',
    gradientBlue: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-gradient-tint-Gradient_Tint-blue_160x160.png?v=1788067718',
    gradientBrown: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-gradient-tint-Gradient_Tint-brown_160x160.png?v=1788067718',
    gradientGray: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-gradient-tint-Gradient_Tint-grey_160x160.png?v=1788067718',
    gradientRed: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-gradient-tint-Gradient_Tint-red_160x160.png?v=1788067718',
    mirrored: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-mirrored-Mirrored-blue_160x160.png?v=1788067720',
    mirroredBlue: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-mirrored-Mirrored-blue_160x160.png?v=1788067720',
    mirroredGold: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-mirrored-Mirrored-gold_160x160.png?v=1788067720',
    mirroredGreen: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-mirrored-Mirrored-green_160x160.png?v=1788067720',
    mirroredSilver: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-mirrored-Mirrored-grey_160x160.png?v=1788067720',
    mirroredOrange: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-mirrored-Mirrored-orange_160x160.png?v=1788067720',
    mirroredPurple: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-mirrored-Mirrored-purple_160x160.png?v=1788067720',
    mirroredRed: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-mirrored-Mirrored-red_160x160.png?v=1788067720',
    polarized: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-polarized-Polarized-brown_160x160.png?v=1788067723',
    polarizedBrown: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-polarized-Polarized-brown_160x160.png?v=1788067723',
    polarizedGreen: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-polarized-Polarized-green_160x160.png?v=1788067723',
    polarizedGray: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-sun-polarized-Polarized-grey_160x160.png?v=1788067723',
    hi161: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-161-high-index-high-index_1.61_160x160.png?v=1788067690',
    hi167: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-167-high-index-high-index_1.67_160x160.png?v=1788067692',
    hi174: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-174-high-index-high-index_1.74_160x160.png?v=1788067694',
    pcStd: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-polycarbonate-standard-Polycarbonate_Standard_160x160.png?v=1788067701',
    pcHigh: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-polycarbonate-high-astigmatism-Astigmatism_Polycarbonate_High_160x160.png?v=1788067703',
    pcUltra: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-polycarbonate-ultra-high-astigmatism-Astigmatism_Polycarbonate_Ultra_High_160x160.png?v=1788067707',
    trivexStd: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-standard-trivex-Standard_Trivex_160x160.png?v=1788067709',
    trivexAdv: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-advanced-trivex-Advanced_Trivex_160x160.png?v=1788067711',
    progressive: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-progressive-clear_160x160.png?v=1788067713',
    bifocal: 'https://cdn.shopify.com/s/files/1/0888/0590/0580/files/lens-flow-bifocal-Bifocal_160x160.png?v=1788067715'
  };

  var DATA = {
    types: [
      { id: 'single', t: 'Single Vision', ic: 'rx-single', d: 'One prescription power for everyday distance or general wear.' },
      { id: 'multifocal', t: 'Multifocal', ic: 'rx-multi', d: 'Progressive or bifocal lenses when your Rx includes ADD.' },
      { id: 'nonrx', t: 'Non-Prescription', ic: 'rx-plano', d: 'No Rx needed. Choose clear, blue-light, photochromic, or sun lenses.' },
      { id: 'frame', t: 'Frame Only', ic: 'frame-only', d: 'Just the frame, no lenses.' }
    ],
    singleOptions: [
      { id: 'clear', t: 'Clear', price: 0, img: IMG.clear, ic: 'lens-clear', d: 'Clear everyday prescription lenses.' },
      { id: 'blue', t: 'Blue Light', price: 10, variantId: V.blue, img: IMG.blue, ic: 'lens-blue', d: 'Blue-light filtering for school and screen time.' },
      { id: 'photo', t: 'Photochromic', price: 40, variantId: V.photo, img: IMG.photo, ic: 'lens-photo', d: 'Turns gray outdoors and clear indoors.' },
      { id: 'sun', t: 'Sunglasses', price: 0, img: IMG.polarizedGray, ic: 'lens-sun', d: 'Prescription sun lenses for bright days.' }
    ],
    nonrxOptions: [
      { id: 'clear', t: 'Clear', price: 0, img: IMG.clear, ic: 'lens-clear', d: 'Clear lenses without prescription power.' },
      { id: 'blue', t: 'Blue Light', price: 10, variantId: V.blue, img: IMG.blue, ic: 'lens-blue', d: 'Screen-time comfort without prescription power.' },
      { id: 'photo', t: 'Photochromic', price: 40, variantId: V.photo, img: IMG.photo, ic: 'lens-photo', d: 'Turns gray outdoors and clear indoors.' },
      { id: 'sun', t: 'Sunglasses', price: 0, img: IMG.polarizedGray, ic: 'lens-sun', d: 'Non-Rx sun lenses for outdoor wear.' }
    ],
    sun: [
      { id: 'classic', t: 'Classic Tint', price: 19, variantId: V.classic, img: IMG.classic, ic: 'tint-classic', d: 'Solid tint for everyday sun protection.' },
      { id: 'gradient', t: 'Gradient Tint', price: 25, variantId: V.gradient, img: IMG.gradient, ic: 'tint-gradient', d: 'Dark on top, lighter below.' },
      { id: 'mirrored', t: 'Mirrored', price: 29, variantId: V.mirrored, img: IMG.mirrored, ic: 'tint-mirror', d: 'Reflective sun coating with a bold look.' },
      { id: 'polarized', t: 'Polarized', price: 39, variantId: V.polarized, img: IMG.polarized, ic: 'tint-polarized', d: 'Reduces glare from roads, water, and snow.' }
    ],
    sunColors: {
      classic: [
        { id: 'gray', t: 'Gray', variantId: 56173380174116, img: IMG.classicGray, swatch: 'gray', d: 'Classic solid gray tint.' },
        { id: 'brown', t: 'Brown / Tea', variantId: 67694317437220, img: IMG.classicBrown, swatch: 'brown', d: 'Classic warm brown tint.' },
        { id: 'green', t: 'Green', variantId: 67694317469988, img: IMG.classicGreen, swatch: 'green', d: 'Classic green sun tint.' }
      ],
      gradient: [
        { id: 'gray-gradient', t: 'Gray Gradient', variantId: 56173380272420, img: IMG.gradientGray, swatch: 'gray-gradient', d: 'Darker gray on top, lighter below.' },
        { id: 'brown-gradient', t: 'Brown Gradient', variantId: 67694317502756, img: IMG.gradientBrown, swatch: 'brown-gradient', d: 'Darker brown on top, lighter below.' },
        { id: 'rose-red-gradient', t: 'Rose / Red Gradient', variantId: 67694317535524, img: IMG.gradientRed, swatch: 'red-gradient', d: 'Warm red gradient tint.' },
        { id: 'blue-purple-gradient', t: 'Blue / Purple Gradient', variantId: 67694317568292, img: IMG.gradientBlue, swatch: 'blue-gradient', d: 'Cool blue gradient tint.' }
      ],
      mirrored: [
        { id: 'silver', t: 'Silver', variantId: 67694317732132, img: IMG.mirroredSilver, swatch: 'silver-mirror', d: 'Reflective silver mirror finish.' },
        { id: 'blue', t: 'Blue', variantId: 67694317601060, img: IMG.mirroredBlue, swatch: 'blue-mirror', d: 'Reflective blue mirror finish.' },
        { id: 'gold', t: 'Gold', variantId: 67694317633828, img: IMG.mirroredGold, swatch: 'gold-mirror', d: 'Reflective gold mirror finish.' },
        { id: 'green', t: 'Green', variantId: 67694317666596, img: IMG.mirroredGreen, swatch: 'green-mirror', d: 'Reflective green mirror finish.' },
        { id: 'red-pink', t: 'Red / Pink', variantId: 67694317699364, img: IMG.mirroredRed, swatch: 'red-mirror', d: 'Reflective red-pink mirror finish.' },
        { id: 'purple', t: 'Purple', variantId: 56173380370724, img: IMG.mirroredPurple, swatch: 'purple-mirror', d: 'Reflective purple mirror finish.' },
        { id: 'orange', t: 'Orange', variantId: 67694317764900, img: IMG.mirroredOrange, swatch: 'orange-mirror', d: 'Reflective orange mirror finish.' }
      ],
      polarized: [
        { id: 'polarized-gray', t: 'Polarized Gray', variantId: 56173380305188, img: IMG.polarizedGray, swatch: 'gray', d: 'Polarized gray sun lens.' },
        { id: 'polarized-brown', t: 'Polarized Brown', variantId: 67694317797668, img: IMG.polarizedBrown, swatch: 'brown', d: 'Polarized brown sun lens.' },
        { id: 'polarized-green', t: 'Polarized Green', variantId: 67694317830436, img: IMG.polarizedGreen, swatch: 'green', d: 'Polarized green sun lens.' }
      ]
    },
    multiTypes: [
      { id: 'progressive', t: 'Progressive', price: 50, variantId: V.progressive, img: IMG.progressive, ic: 'lens-progressive', d: 'No-line lens for distance to near vision.' },
      { id: 'bifocal', t: 'Bifocal', price: 30, variantId: V.bifocal, img: IMG.bifocal, ic: 'lens-bifocal', d: 'Two-zone lens when bifocal is written on the Rx.' }
    ],
    multiOptions: [
      { id: 'clear', t: 'Clear', price: 0, img: IMG.clear, ic: 'lens-clear', d: 'Clear multifocal lenses.' },
      { id: 'blue', t: 'Blue Light', price: 10, variantId: V.blue, img: IMG.blue, ic: 'lens-blue', d: 'Adds blue-light filtering.' }
    ],
    singleMaterials: [
      { id: 'hi161', group: 'High-Index', t: '1.61 High-Index', price: 35, variantId: V.hi161, img: IMG.hi161, sphMin: -6, sphMax: 6, cylMin: -2, cylMax: 2, blockSun: ['polarized'], d: 'Thinner and lighter.' },
      { id: 'hi167', group: 'High-Index', t: '1.67 High-Index', price: 48, variantId: V.hi167, img: IMG.hi167, sphMin: -10, sphMax: 8, cylMin: -4, cylMax: 4, blockSun: ['polarized'], d: 'Slimmer for stronger prescriptions.' },
      { id: 'hi174', group: 'High-Index', t: '1.74 High-Index', price: 119, variantId: V.hi174, img: IMG.hi174, sphMin: -15, sphMax: 10, cylMin: -6, cylMax: 6, d: 'Our thinnest lens for strong prescriptions. Custom-made lens.' },
      { id: 'pcStd', group: 'Polycarbonate', t: 'Standard Polycarbonate', price: 19, variantId: V.pcStd, img: IMG.pcStd, sphMin: -3, sphMax: 3, cylMin: -1, cylMax: 1, d: 'Lightweight and impact-resistant.' },
      { id: 'pcHigh', group: 'Polycarbonate', t: 'Advanced Polycarbonate', price: 29, variantId: V.pcHigh, img: IMG.pcHigh, sphMin: -6, sphMax: 4, cylMin: -2, cylMax: 2, d: 'Durable for stronger prescriptions.' },
      { id: 'pcUltra', group: 'Polycarbonate', t: 'Complex Polycarbonate', price: 79, variantId: V.pcUltra, img: IMG.pcUltra, sphMin: -15, sphMax: 8, cylMin: -6, cylMax: 6, d: 'Made for high prescriptions and astigmatism. Custom-made lens.' },
      { id: 'trivexStd', group: 'Trivex', t: 'Standard Trivex', price: 99, variantId: V.trivexStd, img: IMG.trivexStd, sphMin: -6, sphMax: 4, cylMin: -2, cylMax: 2, d: 'Lightweight, clear, and durable.' },
      { id: 'trivexAdv', group: 'Trivex', t: 'Advanced Trivex', price: 159, variantId: V.trivexAdv, img: IMG.trivexAdv, sphMin: -10, sphMax: 8, cylMin: -4, cylMax: 4, d: 'Premium clarity for stronger prescriptions. Custom-made lens.' }
    ],
    multiMaterials: [
      { id: 'pcStd', group: 'Polycarbonate', t: 'Standard Polycarbonate', price: 19, variantId: V.pcStd, img: IMG.pcStd, sphMin: -3, sphMax: 3, cylMin: -1, cylMax: 1, d: 'Lightweight and impact-resistant.' },
      { id: 'pcHigh', group: 'Polycarbonate', t: 'Advanced Polycarbonate', price: 29, variantId: V.pcHigh, img: IMG.pcHigh, sphMin: -6, sphMax: 4, cylMin: -2, cylMax: 2, d: 'Durable for stronger prescriptions.' },
      { id: 'pcUltra', group: 'Polycarbonate', t: 'Complex Polycarbonate', price: 79, variantId: V.pcUltra, img: IMG.pcUltra, sphMin: -15, sphMax: 8, cylMin: -6, cylMax: 6, d: 'Made for high prescriptions and astigmatism. Custom-made lens.' }
    ]
  };

  function applyShopifyPrices(list) {
    (list || []).forEach(function (item) {
      if (!item || !item.variantId || !CFG.variantPrices) return;
      var livePrice = Number(CFG.variantPrices[String(item.variantId)]);
      if (isFinite(livePrice) && livePrice >= 0) item.price = livePrice;
    });
  }
  [DATA.singleOptions, DATA.nonrxOptions, DATA.sun, DATA.multiTypes, DATA.multiOptions, DATA.singleMaterials, DATA.multiMaterials].forEach(applyShopifyPrices);

  var state = {
    type: null, lensOption: null, sunStyle: null, sunColor: null, multiType: null, multiOption: null, materialGroup: null, material: null,
    method: null, addons: [], notes: '', forName: '', birthYear: '', added: false, busy: false, rxStashDismissed: false, materialConfirmId: null,
    rx: {
      od: { sph: '0.00', cyl: '0.00', axis: '', add: '0.00', prismH: '', baseH: '', prismV: '', baseV: '' },
      os: { sph: '0.00', cyl: '0.00', axis: '', add: '0.00', prismH: '', baseH: '', prismV: '', baseV: '' },
      hasPrism: false, pdMode: 'single', pd: '', pdR: '', pdL: '', pdHelp: false, file: '', fileObject: null, cartFileObject: null, cartFilePromise: null, previewUrl: '', previewType: '',
      ocrStage: 'idle', ocrProgress: 0, ocrConfidence: 0, ocrMissing: [], ocrError: '', ocrSource: ''
    }
  };
  var stepIdx = 0;
  var renderedOnce = false;
  var RX_STASH_KEY = 'eb-rx-stash';
  var RX_STASH_TTL = 2 * 60 * 60 * 1000;

  function hasAddons() { return !!(CFG.addons && CFG.addons.length); }
  function needsRx() { return state.type === 'single' || state.type === 'multifocal'; }
  function needsAdd() { return state.type === 'multifocal'; }
  function needsSunStep() { return (state.type === 'single' || state.type === 'nonrx') && state.lensOption === 'sun'; }
  function needsMaterial() { return state.type === 'single' || state.type === 'multifocal'; }
  function flowSteps() {
    var steps = ['type'];
    if (!state.type) return steps;
    if (state.type === 'frame') {
      if (hasAddons()) steps.push('addons');
      steps.push('review');
      return steps;
    }
    if (state.type === 'multifocal') steps.push('multitype', 'lens');
    else steps.push('lens');
    if (needsSunStep()) steps.push('sun', 'suncolor');
    if (needsRx()) {
      steps.push('method');
      if (state.method === 'manual' || state.method === 'upload') steps.push('rx');
    }
    if (needsMaterial()) steps.push('material');
    if (hasAddons() && state.type !== 'nonrx') steps.push('addons');
    steps.push('review');
    return steps;
  }
  var cur = function () { var s = flowSteps(); if (stepIdx >= s.length) stepIdx = s.length - 1; return s[stepIdx]; };

  function copyEye(eye) {
    var e = state.rx[eye];
    return { sph: e.sph, cyl: e.cyl, axis: e.axis || '', add: e.add || '0.00', prismH: e.prismH || '', baseH: e.baseH || '', prismV: e.prismV || '', baseV: e.baseV || '' };
  }
  function restoreEye(saved) {
    saved = saved || {};
    return { sph: saved.sph || '0.00', cyl: saved.cyl || '0.00', axis: saved.axis || '', add: saved.add || '0.00', prismH: saved.prismH || '', baseH: saved.baseH || '', prismV: saved.prismV || '', baseV: saved.baseV || '' };
  }
  function rxStashLoad() {
    try {
      var s = JSON.parse(sessionStorage.getItem(RX_STASH_KEY));
      if (!s || !s.ts || (Date.now() - s.ts) > RX_STASH_TTL || !s.od || !s.os) return null;
      return s;
    } catch (e) { return null; }
  }
  function rxStashSave() {
    try {
      sessionStorage.setItem(RX_STASH_KEY, JSON.stringify({
        od: copyEye('od'), os: copyEye('os'), hasPrism: state.rx.hasPrism,
        pdMode: state.rx.pdMode, pd: state.rx.pd, pdR: state.rx.pdR, pdL: state.rx.pdL, pdHelp: state.rx.pdHelp, ts: Date.now()
      }));
    } catch (e) {}
  }
  function rxStashSummary(s) {
    var eye = function (e) {
      var ax = parseFloat(e.cyl) !== 0 && e.axis ? ' | x' + String(e.axis).padStart(3, '0') : '';
      var add = parseFloat(e.add) > 0 || (needsAdd() && Number.isFinite(parseFloat(e.add))) ? ' | ADD ' + fmtP(e.add) : '';
      var prism = prismString(e);
      return fmtP(e.sph) + ' | ' + fmtP(e.cyl) + ax + add + (prism ? ' | Prism ' + prism : '');
    };
    var pd = s.pdHelp ? 'Customer needs help' : s.pdMode === 'dual' ? 'Dual | R ' + s.pdR + ' / L ' + s.pdL : 'Single | ' + s.pd;
    return 'OD ' + eye(s.od) + ' / OS ' + eye(s.os) + ' / PD ' + pd;
  }

  function themeVariantInput() {
    var main = document.querySelector('form[x-ref="productForm"] [name="id"]');
    if (main) return main;

    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].hasAttribute('data-eb-form')) continue;
      var el = forms[i].querySelector('[name="id"]');
      if (el) return el;
    }
    return null;
  }
  function currentVariant() {
    var el = themeVariantInput();
    var id = el ? Number(el.value) : CFG.frame.firstAvailable;
    var v = null;
    for (var i = 0; i < CFG.frame.variants.length; i++) {
      if (CFG.frame.variants[i].id === id) { v = CFG.frame.variants[i]; break; }
    }
    return v || CFG.frame.variants[0];
  }
  function syncFrameVariantInput(v) {
    var input = $('[data-eb-frame-variant-id]');
    var variant = v || currentVariant();
    if (input && variant) input.value = String(variant.id);
  }
  function frameName(v) {
    return CFG.frame.hasOnlyDefaultVariant ? CFG.frame.title : CFG.frame.title + ' - ' + v.title;
  }
  function framePdRange() {
    return String(CFG.frame.pdRange || '').trim();
  }
  function customerPdValue() {
    if (!needsRx() || state.method === 'later' || state.rx.pdHelp) return null;
    if (state.rx.pdMode === 'dual') {
      var right = parseFloat(state.rx.pdR), left = parseFloat(state.rx.pdL);
      return isFinite(right) && isFinite(left) ? right + left : null;
    }
    var single = parseFloat(state.rx.pd);
    return isFinite(single) ? single : null;
  }
  function birthYearPdRange() {
    var year = parseInt(state.birthYear, 10);
    if (!isFinite(year)) return '';
    var age = Math.max(1, Math.min(18, new Date().getFullYear() - year));
    function maleMean(age) { return 43.36 + 1.663 * age - 0.034 * age * age; }
    function femaleMean(age) { return 41.76 + 1.891 * age - 0.052 * age * age; }
    return Math.round((femaleMean(age) + maleMean(age)) / 2) + ' mm';
  }
  function birthYearOrderString() {
    var range = birthYearPdRange();
    return range ? state.birthYear + ' PD avg: ' + range : state.birthYear;
  }
  function framePdFitStatus() {
    var range = framePdRange(), pd = customerPdValue();
    if (!range || pd == null) return '';
    var values = range.match(/\d+(?:\.\d+)?/g);
    if (!values || values.length < 2) return '';
    var min = parseFloat(values[0]), max = parseFloat(values[1]);
    if (!isFinite(min) || !isFinite(max)) return '';
    if (pd < min) return 'Review required - customer PD ' + pd.toFixed(2) + ' mm is below the frame range';
    if (pd > max) return 'Review required - customer PD ' + pd.toFixed(2) + ' mm is above the frame range';
    return 'Within listed range - customer PD ' + pd.toFixed(2) + ' mm';
  }
  function renderFramePdWarning(el) {
    var warning = el.querySelector('[data-eb-frame-pd-warning]');
    if (!warning) return;
    var status = framePdFitStatus(), range = framePdRange();
    if (status.indexOf('Review required') !== 0) {
      warning.innerHTML = '';
      return;
    }
    var pd = customerPdValue();
    var message = state.rx.pdMode === 'dual'
      ? 'Combined PD ' + pd.toFixed(2) + ' mm is outside this frame\u2019s PD range: ' + esc(range) + '.'
      : 'Your child\u2019s PD is outside this frame\u2019s PD range: ' + esc(range) + '.';
    warning.innerHTML = '<div class="eb-frame-pd-warning">' + message + '</div>';
  }
  function orderPdString() {
    var value = state.method === 'later' ? 'Send later' : pdString();
    var range = framePdRange();
    return range ? value + '\u00a0\u00a0\u00a0\u00a0\u00a0/\u00a0\u00a0\u00a0\u00a0Range: ' + range : value;
  }
  function syncRxTriggers(v) {
    var variant = v || currentVariant();
    var available = !!(variant && variant.available);
    document.querySelectorAll('[data-eb-rx-open]').forEach(function (btn) {
      btn.disabled = !available;
      btn.setAttribute('aria-disabled', available ? 'false' : 'true');
      var label = btn.querySelector('[data-eb-rx-trigger-label]') || btn.querySelector('span') || btn;
      label.textContent = available ? 'Select Lenses and Purchase' : 'Sold Out';
    });
  }

  // Convert plus-cylinder prescriptions before checking lab-ready lens ranges.
  function normalizeEye(e) {
    var sph = parseFloat(e.sph) || 0;
    var cyl = parseFloat(e.cyl) || 0;
    var axis = parseInt(e.axis, 10);
    if (cyl > 0) {
      sph = sph + cyl;
      cyl = -cyl;
      if (axis) axis = axis + 90 > 180 ? axis - 90 : axis + 90;
    }
    return { sph: sph, cyl: cyl, axis: axis || '' };
  }
  function normalizedEyes() {
    return [normalizeEye(state.rx.od), normalizeEye(state.rx.os)];
  }
  function byId(list, id) {
    for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i];
    return null;
  }
  function materialList() { return state.type === 'multifocal' ? DATA.multiMaterials : DATA.singleMaterials; }
  function materialGroups() {
    var seen = {};
    return materialList().reduce(function (out, m) {
      if (seen[m.group]) return out;
      seen[m.group] = true;
      out.push({ id: m.group, t: m.group, price: 0, img: materialGroupImage(m.group), ic: m.group === 'High-Index' ? 'material-hi' : m.group === 'Trivex' ? 'material-trivex' : 'material-pc', d: materialGroupCopy(m.group) });
      return out;
    }, []);
  }
  function materialGroupImage(group) {
    if (group === 'High-Index') return IMG.hi167;
    if (group === 'Polycarbonate') return IMG.pcStd;
    if (group === 'Trivex') return IMG.trivexStd;
    return '';
  }
  function materialGroupCopy(group) {
    if (group === 'High-Index') return 'Thinner and lighter.';
    if (group === 'Polycarbonate') return 'Lightweight and impact-resistant.';
    if (group === 'Trivex') return 'Lightweight, clear, and durable.';
    return 'Choose a lens material tier.';
  }
  function selectedFunction() {
    if (state.type === 'multifocal') return byId(DATA.multiOptions, state.multiOption);
    if (state.type === 'nonrx') return byId(DATA.nonrxOptions, state.lensOption);
    return byId(DATA.singleOptions, state.lensOption);
  }
  function selectedSun() { return byId(DATA.sun, state.sunStyle); }
  function sunColorList() { return state.sunStyle && DATA.sunColors[state.sunStyle] ? DATA.sunColors[state.sunStyle] : []; }
  function selectedSunColor() { return byId(sunColorList(), state.sunColor); }
  function selectedMultiType() { return byId(DATA.multiTypes, state.multiType); }
  function selectedMaterial() { return byId(materialList(), state.material); }
  function prismFeePrice() { return Number((CFG.prismFee && CFG.prismFee.price) || 9.95); }
  function prismFeeVariantId() { return CFG.prismFee && CFG.prismFee.variantId ? Number(CFG.prismFee.variantId) : null; }
  function prismString(e) {
    var parts = [];
    if (parseFloat(e.prismH) > 0 && e.baseH) parts.push(e.prismH + ' ' + e.baseH);
    if (parseFloat(e.prismV) > 0 && e.baseV) parts.push(e.prismV + ' ' + e.baseV);
    return parts.join(' / ');
  }
  function eyePrismString(eye) { return prismString(state.rx[eye]); }
  function hasPrismValues() { return !!(eyePrismString('od') || eyePrismString('os')); }
  function chargePrism() { return state.rx.hasPrism && (state.method === 'upload' || hasPrismValues()); }
  function clearPrismValues() {
    ['od', 'os'].forEach(function (eye) {
      state.rx[eye].prismH = ''; state.rx[eye].baseH = ''; state.rx[eye].prismV = ''; state.rx[eye].baseV = '';
    });
  }

  function materialConfirmation(m) {
    if (!m) return null;
    if ((state.lensOption === 'photo' || state.lensOption === 'sun') && (m.id === 'hi174' || m.id === 'pcUltra')) {
      return {
        notice: 'Manual review required for this complex lens.',
        message: 'This lens can be made, but it is more complex and requires manual review. We will contact you if any changes are needed.'
      };
    }
    return null;
  }
  function materialCompatible(m) {
    if (!m) return { ok: false, why: 'Choose a material.' };
    if (m.group === 'Trivex' && state.type === 'multifocal') return { ok: false, why: 'Trivex is not available for multifocal lenses.' };
    if (m.group === 'Trivex' && state.lensOption === 'blue') return { ok: false, why: 'Not available with Blue Light.' };
    if (m.blockOptions && m.blockOptions.indexOf(state.lensOption) !== -1) return { ok: false, why: 'Not available with this lens option.' };
    if (state.lensOption === 'sun' && m.blockSun && m.blockSun.indexOf(state.sunStyle) !== -1) return { ok: false, why: 'Not available with polarized lenses.' };
    var confirmation = materialConfirmation(m);
    if (confirmation) return { ok: true, why: confirmation.notice };
    if (state.method !== 'manual' && state.method !== 'upload') return { ok: true };
    var eyes = normalizedEyes();
    var sphMin = Number(m.sphMin == null ? -Math.abs(Number(m.sph || 0)) : m.sphMin);
    var sphMax = Number(m.sphMax == null ? Math.abs(Number(m.sph || 0)) : m.sphMax);
    var cylMin = Number(m.cylMin == null ? -Math.abs(Number(m.cyl || 0)) : m.cylMin);
    var cylMax = Number(m.cylMax == null ? Math.abs(Number(m.cyl || 0)) : m.cylMax);
    for (var i = 0; i < eyes.length; i++) {
      if (eyes[i].sph < sphMin || eyes[i].sph > sphMax) return { ok: false, why: 'SPH is outside this lens range.' };
      if (eyes[i].cyl < cylMin || eyes[i].cyl > cylMax) return { ok: false, why: 'CYL is outside this lens range.' };
    }
    return { ok: true };
  }
  function complexLensNeedsReview() {
    return (state.lensOption === 'photo' || state.lensOption === 'sun') && (state.material === 'hi174' || state.material === 'pcUltra');
  }

  function componentList() {
    var out = [];
    function add(c, kind, variantId) {
      var selectedVariantId = variantId || (c && c.variantId);
      if (c && Number(c.price) > 0 && selectedVariantId) out.push({ name: c.t, price: Number(c.price), variantId: Number(selectedVariantId), kind: kind });
    }
    add(selectedMultiType(), 'Multifocal Type');
    add(selectedFunction(), 'Lens Option');
    add(selectedSun(), 'Sunglasses', selectedSunColor() && selectedSunColor().variantId);
    add(selectedMaterial(), 'Lens Material');
    return out;
  }
  function lensLabel() {
    if (state.type === 'frame') return 'Frame Only';
    var parts = [];
    if (state.type === 'single') parts.push('Single Vision');
    if (state.type === 'multifocal') parts.push(selectedMultiType() ? selectedMultiType().t : 'Multifocal');
    if (state.type === 'nonrx') parts.push('Non-Prescription');
    if (selectedFunction()) parts.push(selectedFunction().t);
    if (state.lensOption === 'sun' && selectedSun()) parts.push(selectedSun().t);
    if (state.lensOption === 'sun' && selectedSunColor()) parts.push(selectedSunColor().t);
    if (selectedMaterial()) parts.push(selectedMaterial().t);
    return parts.join(' / ');
  }
  function typeLabel() {
    return { single: 'Single Vision', multifocal: 'Multifocal', nonrx: 'Non-Prescription', frame: 'Frame Only' }[state.type] || '';
  }
  function frameMethod() {
    return state.method === 'upload' ? 'Upload Prescription' : state.method === 'later' ? 'Send Later' : 'Enter Manually';
  }
  function chosenAddons() { return CFG.addons.filter(function (a) { return state.addons.indexOf(a.id) !== -1; }); }

  function opts(sel, from, to, step, fmt, chosen, blank) {
    var h = blank ? '<option value="">Choose</option>' : '';
    var dir = from > to ? -1 : 1;
    for (var v = from; dir > 0 ? v <= to + 1e-9 : v >= to - 1e-9; v += step * dir) {
      var val = v.toFixed(step < 1 ? 2 : 0);
      h += '<option value="' + val + '"' + (val === chosen ? ' selected' : '') + '>' + (fmt ? fmt(val) : val) + '</option>';
    }
    sel.innerHTML = h;
  }
  function directionOpts(sel, choices, chosen) {
    sel.innerHTML = '<option value="">Choose</option>' + choices.map(function (c) {
      return '<option value="' + c + '"' + (c === chosen ? ' selected' : '') + '>' + c + '</option>';
    }).join('');
  }
  function birthYearOptions() {
    var current = new Date().getFullYear(), out = '<option value="">Select birth year</option>';
    for (var year = current - 1; year >= current - 18; year--) {
      out += '<option value="' + year + '"' + (String(year) === String(state.birthYear) ? ' selected' : '') + '>' + year + '</option>';
    }
    return out;
  }
  function materialTierIcon(m) {
    if (m.group === 'High-Index') return m.id === 'hi174' ? 'tier-hi-174' : m.id === 'hi167' ? 'tier-hi-167' : 'tier-hi-161';
    if (m.group === 'Trivex') return m.id === 'trivexAdv' ? 'tier-trivex-advanced' : 'tier-trivex-standard';
    return m.id === 'pcUltra' ? 'tier-cyl-ultra' : m.id === 'pcHigh' ? 'tier-cyl-high' : 'tier-standard';
  }
  function largeImageUrl(url) {
    return String(url || '').replace(/_160x160(\.[a-z]+)(\?v=)/i, '_900x900$1$2');
  }
  function openImagePreview(url, title) {
    if (!url) return;
    var old = root.querySelector('[data-eb-imgpreview]');
    if (old) old.remove();
    var wrap = document.createElement('div');
    wrap.className = 'eb-imgpreview';
    wrap.dataset.ebImgpreview = '1';
    wrap.innerHTML = '<button type="button" class="eb-imgpreview__close" aria-label="Close image preview">×</button><figure><img src="' + esc(largeImageUrl(url)) + '" alt="' + esc(title || 'Lens preview') + '"><figcaption>' + esc(title || '') + '</figcaption></figure>';
    root.appendChild(wrap);
    function close() { wrap.remove(); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    wrap.onclick = function (e) { if (e.target === wrap) close(); };
    wrap.querySelector('.eb-imgpreview__close').onclick = close;
    document.addEventListener('keydown', onKey);
  }
  function iconSvg(name) {
    var icons = {
      'rx-single': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M5.3 7.3c2.1-1.4 4.7-.7 5.7 1.6.7 1.6.7 4.6 0 6.2-1 2.3-3.6 3-5.7 1.6-2.5-1.7-2.5-7.7 0-9.4Z"></path><path class="lens-fill" d="M18.7 7.3c-2.1-1.4-4.7-.7-5.7 1.6-.7 1.6-.7 4.6 0 6.2 1 2.3 3.6 3 5.7 1.6 2.5-1.7 2.5-7.7 0-9.4Z"></path><path d="M11 12h2M4 8.5 3 6M20 8.5 21 6"></path><path class="accent" d="M7 11h2.8M14.2 11H17"></path></svg>',
      'rx-multi': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M7 4h10c1.4 0 2.5 1.1 2.5 2.5v11c0 1.4-1.1 2.5-2.5 2.5H7c-1.4 0-2.5-1.1-2.5-2.5v-11C4.5 5.1 5.6 4 7 4Z"></path><path d="M7.5 8.5h9M7.5 12h9M8.5 16h7"></path><path class="accent" d="M12 5v14"></path></svg>',
      'rx-plano': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M7 5h10c1.8 0 3 1.6 2.6 3.4l-1.5 7.2A4.2 4.2 0 0 1 14 19H10a4.2 4.2 0 0 1-4.1-3.4L4.4 8.4C4 6.6 5.2 5 7 5Z"></path><path d="M8 12h8"></path><path class="accent" d="M9 15h6"></path></svg>',
      'frame-only': '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 11.5c1-2.2 5.4-2.2 6.5 0 .7 1.6 0 4.2-2.5 4.2H6.5c-2 0-3.2-2.2-2.5-4.2ZM20 11.5c-1-2.2-5.4-2.2-6.5 0-.7 1.6 0 4.2 2.5 4.2h1.5c2 0 3.2-2.2 2.5-4.2Z"></path><path d="M10.5 12h3M4.3 10 3 7M19.7 10 21 7"></path></svg>',
      'lens-clear': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M8 4.5h8c1.8 0 3 1.6 2.7 3.3l-1.4 7.4A5.4 5.4 0 0 1 12 19.5a5.4 5.4 0 0 1-5.3-4.3L5.3 7.8C5 6.1 6.2 4.5 8 4.5Z"></path><path class="accent" d="M8.5 9.5h7M9.5 13h5"></path></svg>',
      'lens-blue': '<svg viewBox="0 0 24 24" aria-hidden="true"><rect class="lens-fill" x="5" y="5" width="14" height="10" rx="2"></rect><path d="M9 19h6M12 15v4"></path><path class="accent" d="M8 8.5h8M8 11.5h5"></path></svg>',
      'lens-photo': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M8 4.5h8c1.8 0 3 1.6 2.7 3.3l-1.4 7.4A5.4 5.4 0 0 1 12 19.5a5.4 5.4 0 0 1-5.3-4.3L5.3 7.8C5 6.1 6.2 4.5 8 4.5Z"></path><path class="accent" d="M6.8 12h10.4M12 5v14"></path><path d="M18 3.5v2M18 8.5v2M14.5 7h2M19.5 7h2"></path></svg>',
      'lens-sun': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M4 10h6.5l-.9 5.2H6L4 10ZM20 10h-6.5l.9 5.2H18l2-5.2Z"></path><path d="M10.5 11.5h3M5 8l-1-2M19 8l1-2"></path><path class="accent" d="M6.2 12.4h2.2M15.6 12.4h2.2"></path></svg>',
      'tint-classic': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M7 5h10c1.6 0 2.7 1.4 2.3 3l-1.5 7.2A4.5 4.5 0 0 1 13.4 19h-2.8a4.5 4.5 0 0 1-4.4-3.8L4.7 8C4.3 6.4 5.4 5 7 5Z"></path><path class="accent" d="M7.2 14.5h9.6"></path></svg>',
      'tint-gradient': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M7 5h10c1.6 0 2.7 1.4 2.3 3l-1.5 7.2A4.5 4.5 0 0 1 13.4 19h-2.8a4.5 4.5 0 0 1-4.4-3.8L4.7 8C4.3 6.4 5.4 5 7 5Z"></path><path d="M7 8.5h10M7.7 11.5h8.6M8.6 14.5h6.8"></path><path class="accent" d="M10 17h4"></path></svg>',
      'tint-mirror': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M7 5h10c1.6 0 2.7 1.4 2.3 3l-1.5 7.2A4.5 4.5 0 0 1 13.4 19h-2.8a4.5 4.5 0 0 1-4.4-3.8L4.7 8C4.3 6.4 5.4 5 7 5Z"></path><path class="accent" d="m8 15 8-8M11.5 17.5l5.2-5.2"></path></svg>',
      'tint-polarized': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M7 5h10c1.6 0 2.7 1.4 2.3 3l-1.5 7.2A4.5 4.5 0 0 1 13.4 19h-2.8a4.5 4.5 0 0 1-4.4-3.8L4.7 8C4.3 6.4 5.4 5 7 5Z"></path><path d="M8 9c1.3 0 1.3-1 2.6-1s1.3 1 2.6 1 1.3-1 2.8-1"></path><path class="accent" d="M8 13c1.3 0 1.3-1 2.6-1s1.3 1 2.6 1 1.3-1 2.8-1"></path><path d="M8 17c1.3 0 1.3-1 2.6-1s1.3 1 2.6 1 1.3-1 2.8-1"></path></svg>',
      'lens-progressive': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M8 4.5h8c1.8 0 3 1.6 2.7 3.3l-1.4 7.4A5.4 5.4 0 0 1 12 19.5a5.4 5.4 0 0 1-5.3-4.3L5.3 7.8C5 6.1 6.2 4.5 8 4.5Z"></path><path d="M8.5 8.5h7M9 12h6M10 15.5h4"></path><path class="accent" d="M12 6.5c1.4 2.8 1.4 8.2 0 11"></path></svg>',
      'lens-bifocal': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M8 4.5h8c1.8 0 3 1.6 2.7 3.3l-1.4 7.4A5.4 5.4 0 0 1 12 19.5a5.4 5.4 0 0 1-5.3-4.3L5.3 7.8C5 6.1 6.2 4.5 8 4.5Z"></path><path d="M7 13h10"></path><path class="accent" d="M9 16h6"></path></svg>',
      'material-hi': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M7.5 5h9l2 7-6.5 7-6.5-7 2-7Z"></path><path d="M7.5 5 12 19 16.5 5"></path><path class="accent" d="M6 12h12"></path></svg>',
      'material-pc': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M12 3.8 19 6.5v5.2c0 4.1-2.8 7.5-7 8.9-4.2-1.4-7-4.8-7-8.9V6.5l7-2.7Z"></path><path class="accent" d="M8.8 12l2.1 2.1 4.3-4.6"></path></svg>',
      'material-trivex': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M12 4 19 8v8l-7 4-7-4V8l7-4Z"></path><path d="M12 4v16M5 8l7 4 7-4"></path><path class="accent" d="m7.5 15 4.5-3 4.5 3"></path></svg>',
      'tier-hi-161': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M8 5h8l2 7-6 7-6-7 2-7Z"></path><path class="accent" d="M8.5 12h7"></path></svg>',
      'tier-hi-167': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M8 5h8l2 7-6 7-6-7 2-7Z"></path><path d="M9 9h6"></path><path class="accent" d="M8.5 13h7"></path></svg>',
      'tier-hi-174': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M8 5h8l2 7-6 7-6-7 2-7Z"></path><path d="M9.5 8.5h5M8.8 12h6.4"></path><path class="accent" d="M9.5 15.5h5"></path></svg>',
      'tier-standard': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M8 4.5h8c1.8 0 3 1.6 2.7 3.3l-1.4 7.4A5.4 5.4 0 0 1 12 19.5a5.4 5.4 0 0 1-5.3-4.3L5.3 7.8C5 6.1 6.2 4.5 8 4.5Z"></path><path class="accent" d="M9 12h6"></path></svg>',
      'tier-cyl-high': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M8 4.5h8c1.8 0 3 1.6 2.7 3.3l-1.4 7.4A5.4 5.4 0 0 1 12 19.5a5.4 5.4 0 0 1-5.3-4.3L5.3 7.8C5 6.1 6.2 4.5 8 4.5Z"></path><path d="M8 9c2.2 2.2 5.8 2.2 8 0"></path><path class="accent" d="M8 15c2.2-2.2 5.8-2.2 8 0"></path></svg>',
      'tier-cyl-ultra': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M8 4.5h8c1.8 0 3 1.6 2.7 3.3l-1.4 7.4A5.4 5.4 0 0 1 12 19.5a5.4 5.4 0 0 1-5.3-4.3L5.3 7.8C5 6.1 6.2 4.5 8 4.5Z"></path><path d="M7.8 8.8c2.4 2.4 6 2.4 8.4 0M7.8 15.2c2.4-2.4 6-2.4 8.4 0"></path><path class="accent" d="M12 6.8v10.4"></path></svg>',
      'tier-trivex-standard': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M12 4 18.5 8v8L12 20 5.5 16V8L12 4Z"></path><path class="accent" d="M8.5 12h7"></path></svg>',
      'tier-trivex-advanced': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M12 4 18.5 8v8L12 20 5.5 16V8L12 4Z"></path><path d="M8.5 10h7M8.5 14h7"></path><path class="accent" d="M12 6v12"></path></svg>',
      'method-manual': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M6 4.5h12v15H6z"></path><path d="M8.5 8h7M8.5 11.5h7M8.5 15h4"></path><path class="accent" d="m14 16 3 3 2-5-5 2Z"></path></svg>',
      'method-upload': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M7 4.5h7l3 3v12H7z"></path><path d="M14 4.5V8h3"></path><path class="accent" d="M12 16V9.5M9.5 12l2.5-2.5 2.5 2.5"></path></svg>',
      'method-later': '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="lens-fill" d="M12 20a7.5 7.5 0 1 0-7.5-7.5A7.5 7.5 0 0 0 12 20Z"></path><path d="M12 8v4.5l3 1.8"></path><path class="accent" d="M6 4.5 4.5 6M18 4.5 19.5 6"></path></svg>'
    };
    return icons[name] || icons['lens-clear'];
  }
  function choice(c, selected, disabled, why) {
    var hasPrice = Number(c.price) > 0;
    var icon = c.img ? '<span class="eb-imgicon" role="button" tabindex="0" aria-label="View larger image for ' + esc(c.t) + '" data-img="' + esc(c.img) + '" data-img-title="' + esc(c.t) + '"><img src="' + esc(c.img) + '" alt="" loading="lazy"></span>' : c.swatch ? '<span class="eb-colorchip eb-colorchip--' + esc(c.swatch) + '"></span>' : '<span class="eb-ic eb-ic--' + esc(c.ic || 'lens-clear') + '">' + iconSvg(c.ic) + '</span>';
    return '<button type="button" class="eb-choice' + (hasPrice ? '' : ' eb-choice--noprice') + (selected ? ' eb-choice--selected' : '') + (disabled ? ' eb-choice--incompat' : '') +
      '" data-k="' + esc(c.id) + '"' + (disabled ? ' disabled' : '') + '>' +
      icon +
      '<span class="eb-choice__body"><span class="eb-choice__head"><span class="eb-t">' + esc(c.t) + '</span>' + (c.badge ? '<span class="eb-recommended-badge">' + esc(c.badge) + '</span>' : '') + '</span>' +
      '<div class="eb-d">' + esc(c.d || '') + (c.range ? '<strong class="eb-range">' + esc(c.range) + '</strong>' : '') + (why ? '<div class="eb-why">' + esc(why) + '</div>' : '') + '</div></span>' +
      (hasPrice ? '<span class="eb-price">' + money(c.price) + '</span>' : '') + '</button>';
  }
  function renderChoices(el, title, hint, list, current, cb, compat) {
    el.innerHTML = '<h2>' + esc(title) + '</h2>' + (hint ? '<p class="eb-hint eb-step-hint">' + esc(hint) + '</p>' : '') +
      list.map(function (c) {
        var ok = compat ? compat(c) : { ok: true };
        return choice(c, current === c.id, !ok.ok, ok.why);
      }).join('');
    el.querySelectorAll('.eb-choice:not([disabled])').forEach(function (b) {
      b.onclick = function () { if (cb(b.dataset.k) !== false) advance(); };
    });
    wireImagePreviews(el);
  }
  function wireImagePreviews(el) {
    el.querySelectorAll('.eb-imgicon[data-img]').forEach(function (img) {
      img.onclick = function (e) {
        e.preventDefault();
        e.stopPropagation();
        openImagePreview(img.dataset.img, img.dataset.imgTitle);
      };
      img.onkeydown = function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          openImagePreview(img.dataset.img, img.dataset.imgTitle);
        }
      };
    });
  }
  function closeSelectMenus(except) {
    root.querySelectorAll('.eb-select--open').forEach(function (w) {
      if (w !== except) {
        w.classList.remove('eb-select--open');
        var b = w.querySelector('.eb-select__btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  }
  function isSignedRxSelect(s) {
    return s.matches && s.matches('select[data-eye][data-f="sph"],select[data-eye][data-f="cyl"]');
  }
  function enhanceSelects(scope) {
    scope.querySelectorAll('select:not([data-eb-enhanced])').forEach(function (s) {
      var wrap = document.createElement('span');
      var btn = document.createElement('button');
      var menu = document.createElement('span');
      var signed = isSignedRxSelect(s);
      var choose = function (value) {
        s.value = value;
        closeSelectMenus();
        s.dispatchEvent(new Event('change', { bubbles: true }));
      };
      var sync = function () {
        var opt = s.options[s.selectedIndex];
        btn.textContent = opt ? opt.textContent : 'Choose';
        btn.disabled = s.disabled;
        menu.querySelectorAll('.eb-select__option').forEach(function (item) {
          item.setAttribute('aria-selected', item.dataset.value === s.value ? 'true' : 'false');
        });
      };
      s.dataset.ebEnhanced = '1';
      s.tabIndex = -1;
      wrap.className = 'eb-select';
      if (signed) wrap.className += ' eb-select--signed';
      if (s.matches('[data-eb-pd1],[data-eb-pdr],[data-eb-pdl]')) wrap.className += ' eb-select--pd';
      btn.type = 'button';
      btn.className = 'eb-select__btn';
      btn.setAttribute('aria-haspopup', 'listbox');
      btn.setAttribute('aria-expanded', 'false');
      menu.className = 'eb-select__menu' + (signed ? ' eb-select__menu--signed' : '');
      menu.setAttribute('role', 'listbox');
      function optionButton(o, empty) {
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'eb-select__option' + (empty ? ' eb-select__option--empty' : '');
        item.textContent = empty ? '' : o.textContent;
        item.dataset.value = empty ? '' : o.value;
        item.setAttribute('role', 'option');
        if (!empty && o.selected) item.setAttribute('aria-selected', 'true');
        if (empty) item.disabled = true;
        else item.onclick = function () { choose(o.value); };
        return item;
      }
      if (signed) {
        var optsList = Array.prototype.filter.call(s.options, function (o) { return o.value !== ''; });
        var zero = optsList.find(function (o) { return Math.abs(parseFloat(o.value)) < 1e-9; });
        var neg = optsList.filter(function (o) { return parseFloat(o.value) < 0; }).sort(function (a, b) { return parseFloat(b.value) - parseFloat(a.value); });
        var pos = optsList.filter(function (o) { return parseFloat(o.value) > 0; }).sort(function (a, b) { return parseFloat(a.value) - parseFloat(b.value); });
        if (zero) {
          var zeroBtn = optionButton(zero);
          zeroBtn.className += ' eb-select__option--zero';
          menu.appendChild(zeroBtn);
        }
        var grid = document.createElement('span');
        grid.className = 'eb-select__signed-grid';
        for (var i = 0, n = Math.max(neg.length, pos.length); i < n; i++) {
          grid.appendChild(neg[i] ? optionButton(neg[i]) : optionButton({}, true));
          grid.appendChild(pos[i] ? optionButton(pos[i]) : optionButton({}, true));
        }
        menu.appendChild(grid);
      } else {
        Array.prototype.forEach.call(s.options, function (o) {
          menu.appendChild(optionButton(o));
        });
      }
      btn.onclick = function () {
        var open = wrap.classList.contains('eb-select--open');
        closeSelectMenus(open ? null : wrap);
        wrap.classList.toggle('eb-select--open', !open);
        btn.setAttribute('aria-expanded', !open ? 'true' : 'false');
        if (!open) setTimeout(function () { wrap.scrollIntoView({ block: 'nearest' }); }, 0);
      };
      s.addEventListener('change', sync);
      s.parentNode.insertBefore(wrap, s);
      wrap.appendChild(s);
      wrap.appendChild(btn);
      wrap.appendChild(menu);
      sync();
    });
  }
  function render() {
    renderedOnce = true;
    var steps = flowSteps();
    if (stepIdx >= steps.length) stepIdx = steps.length - 1;
    $('[data-eb-bar]').style.width = ((stepIdx + 1) / steps.length * 100) + '%';
    $('[data-eb-stepname]').textContent = 'Step ' + (stepIdx + 1) + ' of ' + steps.length;
    $('[data-eb-back]').disabled = stepIdx === 0 || state.added;
    var el = $('[data-eb-step]');
    ({ type: renderType, lens: renderLens, sun: renderSun, suncolor: renderSunColor, multitype: renderMultiType,
      method: renderMethod, rx: renderRx, material: renderMaterial, addons: renderAddons, review: renderReview })[cur()](el);
    enhanceSelects(el);
    syncSummary(); syncNext();
  }
  function resetStepScroll() {
    var scroller = root.querySelector('.eb-panel__body');
    if (!scroller) return;
    var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    requestAnimationFrame(function () { scroller.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' }); });
  }
  function advance() { if (stepIdx < flowSteps().length - 1) stepIdx++; render(); resetStepScroll(); }

  function renderType(el) {
    renderChoices(el, 'Choose Your Lenses', '', DATA.types, state.type, function (k) {
      if (state.type !== k) {
        state.type = k; state.lensOption = null; state.sunStyle = null; state.sunColor = null; state.multiType = null; state.multiOption = null; state.materialGroup = null; state.material = null; state.materialConfirmId = null;
        state.method = (k === 'single' || k === 'multifocal') ? 'manual' : null;
      }
    });
  }
  function renderLens(el) {
    if (state.type === 'multifocal') {
      renderChoices(el, 'Choose Multifocal Option', 'Choose clear lenses, or add blue-light filtering.', DATA.multiOptions, state.multiOption, function (k) {
        state.multiOption = k; state.materialGroup = null; state.material = null; state.materialConfirmId = null;
      });
      return;
    }
    var list = state.type === 'nonrx' ? DATA.nonrxOptions : DATA.singleOptions;
    renderChoices(el, 'Choose Lens Option', 'Pick the lens function first. Materials and prescription limits come next.', list, state.lensOption, function (k) {
      state.lensOption = k; state.sunStyle = null; state.sunColor = null; state.materialGroup = null; state.material = null; state.materialConfirmId = null;
    });
  }
  function renderSun(el) {
    renderChoices(el, 'Choose Sunglasses Style', '', DATA.sun, state.sunStyle, function (k) { state.sunStyle = k; state.sunColor = null; state.materialGroup = null; state.material = null; state.materialConfirmId = null; });
  }
  function renderSunColor(el) {
    var sun = selectedSun();
    renderChoices(el, 'Choose Lens Color', sun ? 'Select the color for ' + sun.t + '.' : '', sunColorList(), state.sunColor, function (k) {
      state.sunColor = k;
    });
  }
  function renderMultiType(el) {
    renderChoices(el, 'Choose Multifocal Type', 'Use this only when the prescription includes ADD.', DATA.multiTypes, state.multiType, function (k) {
      state.multiType = k; state.multiOption = null; state.materialGroup = null; state.material = null; state.materialConfirmId = null;
    });
  }
  function renderMethod(el) {
    var manualCopy = 'Enter SPH, CYL, AXIS and PD to instantly see all eligible lens options.';
    var items = [
      { id: 'manual', t: 'Enter Manually', badge: 'Recommended', price: 0, ic: 'method-manual', d: manualCopy },
      { id: 'upload', t: 'Upload Prescription', price: 0, ic: 'method-upload', d: 'Upload a photo or PDF to scan and prefill the prescription.' },
      { id: 'later', t: 'Send Later', price: 0, ic: 'method-later', d: 'Order now—we’ll contact you for your prescription. Some lens options may cost extra.' }
    ];
    renderChoices(el, 'Prescription Method', '', items, state.method, function (k) {
      if (state.method !== k) {
        var input = $('[data-eb-rxfile]');
        if (input) input.value = '';
        if (state.rx.previewUrl) URL.revokeObjectURL(state.rx.previewUrl);
        state.rx.file = '';
        state.rx.fileObject = null;
        state.rx.cartFileObject = null;
        state.rx.cartFilePromise = null;
        state.rx.previewUrl = '';
        state.rx.previewType = '';
        state.rx.ocrStage = 'idle';
        state.rx.ocrProgress = 0;
        state.rx.ocrConfidence = 0;
        state.rx.ocrMissing = [];
        state.rx.ocrError = '';
        state.rx.ocrSource = '';
      }
      state.method = k;
      if (k === 'upload' && window.EyeBuddyRxOcr && window.EyeBuddyRxOcr.prewarm) {
        window.EyeBuddyRxOcr.prewarm();
      }
      state.materialGroup = null;
      state.material = null;
      state.materialConfirmId = null;
    });
  }
  function eyeBlock(which, label) {
    var add = needsAdd() ? '<div><label class="eb-f">ADD</label><select data-eye="' + which + '" data-f="add"></select></div>' : '';
    return '<div class="eb-eye"><h3>' + label + '</h3><div class="eb-grid' + (needsAdd() ? '4' : '3') + '">' +
      '<div><label class="eb-f">SPH</label><select data-eye="' + which + '" data-f="sph"></select></div>' +
      '<div><label class="eb-f">CYL</label><select data-eye="' + which + '" data-f="cyl"></select></div>' +
      '<div><label class="eb-f">AXIS</label><select data-eye="' + which + '" data-f="axis"></select></div>' + add +
      '</div><div class="eb-fielderr" data-err="' + which + '" style="display:none"></div></div>';
  }
  function prismBlock(which, label) {
    return '<div class="eb-prism-eye"><h4>' + label + '</h4><div class="eb-prism-grid">' +
      '<div><label class="eb-f">Horizontal</label><select data-prism-eye="' + which + '" data-prism-f="prismH"></select></div>' +
      '<div><label class="eb-f">Base</label><select data-prism-eye="' + which + '" data-prism-f="baseH"></select></div>' +
      '<div><label class="eb-f">Vertical</label><select data-prism-eye="' + which + '" data-prism-f="prismV"></select></div>' +
      '<div><label class="eb-f">Base</label><select data-prism-eye="' + which + '" data-prism-f="baseV"></select></div>' +
      '</div><div class="eb-fielderr" data-err="' + which + '-prism" style="display:none"></div></div>';
  }
  function uploadScannerHtml() {
    var progress = Math.max(0, Math.min(100, Math.round(Number(state.rx.ocrProgress || 0) * 100)));
    if (state.rx.ocrStage === 'scanning') {
      return '<div class="eb-ocr-status" role="status"><span class="eb-ocr-spinner" aria-hidden="true"></span><div class="eb-ocr-activity"><span>Reading your prescription...</span><span>Checking every number and sign for accuracy...</span><span>Finding SPH, CYL, AXIS and PD...</span></div><span class="eb-ocr-status__soon">Almost ready. Please keep this window open.</span><div class="eb-ocr-meter"><i style="width:' + progress + '%"></i></div></div>';
    }
    var error = state.rx.ocrError ? '<div class="eb-ocr-error" role="alert">' + esc(state.rx.ocrError) + '</div>' : '';
    return '<button type="button" class="eb-ocr-upload" data-eb-attach><span class="eb-ocr-upload__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m17 8-5-5-5 5"/><path d="M12 3v12"/></svg></span><b>' + (state.rx.file ? 'Choose another photo or PDF' : 'Choose photo or PDF') + '</b><span class="eb-ocr-formats">JPEG, PNG, WEBP or PDF, up to 10 MB</span></button>' + error + '<div class="eb-fielderr" data-eb-fileerr style="display:none"></div>';
  }
  function ocrFieldName(field) {
    return ({ 'od.sph': 'OD SPH', 'od.cyl': 'OD CYL', 'od.axis': 'OD AXIS', 'od.add': 'OD ADD', 'os.sph': 'OS SPH', 'os.cyl': 'OS CYL', 'os.axis': 'OS AXIS', 'os.add': 'OS ADD', pd: 'PD' })[field] || field;
  }
  function ocrReviewHtml() {
    var missing = state.rx.ocrMissing || [];
    var preview = '';
    if (state.rx.previewUrl) {
      if (state.rx.previewType === 'application/pdf') {
        preview = '<details class="eb-ocr-preview"><summary>View uploaded prescription</summary><div class="eb-ocr-preview__media"><iframe src="' + esc(state.rx.previewUrl) + '#toolbar=0" title="Uploaded prescription PDF"></iframe></div></details>';
      } else {
        var image = '<img src="' + esc(state.rx.previewUrl) + '" alt="Uploaded prescription: ' + esc(state.rx.file) + '">';
        preview = '<details class="eb-ocr-preview"><summary>View uploaded prescription</summary><div class="eb-ocr-preview__media"><button type="button" class="eb-ocr-preview__zoom" data-eb-ocr-zoom aria-label="Enlarge uploaded prescription">' + image + '</button></div></details>' +
          '<dialog class="eb-ocr-lightbox" data-eb-ocr-lightbox><button type="button" class="eb-ocr-lightbox__close" data-eb-ocr-lightbox-close aria-label="Close enlarged prescription">&times;</button>' + image + '</dialog>';
      }
    }
    return '<div class="eb-ocr-review' + (missing.length ? ' eb-ocr-review--partial' : '') + '">' +
      '<div class="eb-ocr-review__main"><span class="eb-ocr-review__mark" aria-hidden="true">' + (missing.length ? '!' : '&#10003;') + '</span><div><b>Please check every value before continuing.</b></div></div>' +
      '<div class="eb-ocr-review__actions"><button type="button" class="eb-ocr-replace" data-eb-attach>Replace image</button>' + preview + '</div></div>';
  }
  function applyOcrResult(result) {
    var values = result && result.values ? result.values : {};
    ['od', 'os'].forEach(function (eye) {
      var found = values[eye] || {};
      state.rx[eye].sph = found.sph == null ? '' : found.sph;
      state.rx[eye].cyl = found.cyl == null ? '' : found.cyl;
      state.rx[eye].axis = found.axis == null ? '' : found.axis;
      state.rx[eye].add = found.add == null ? (needsAdd() ? '' : '0.00') : found.add;
    });
    if (values.pd && values.pd.mode === 'dual') {
      state.rx.pdMode = 'dual'; state.rx.pd = ''; state.rx.pdR = values.pd.right; state.rx.pdL = values.pd.left;
    } else if (values.pd && values.pd.mode === 'single') {
      state.rx.pdMode = 'single'; state.rx.pd = values.pd.value; state.rx.pdR = ''; state.rx.pdL = '';
    } else {
      state.rx.pdMode = 'single'; state.rx.pd = ''; state.rx.pdR = ''; state.rx.pdL = '';
    }
    state.rx.pdHelp = false;
    state.rx.hasPrism = !!values.hasPrism;
    state.rx.ocrMissing = result.missing || [];
    state.rx.ocrConfidence = Number(result.confidence || 0);
    state.rx.ocrSource = result.source || '';
    state.rx.ocrError = '';
    state.rx.ocrStage = 'review';
  }
  function pdChooserHtml() {
    return '<h3 class="eb-pdtitle">Pupillary Distance (PD)</h3><div class="eb-pdrow"><label><input type="radio" name="eb-pdm" value="single"' + (state.rx.pdMode === 'single' ? ' checked' : '') + '> Single PD</label>' +
      '<label><input type="radio" name="eb-pdm" value="dual"' + (state.rx.pdMode === 'dual' ? ' checked' : '') + '> Dual PD</label>' +
      '<label><input type="radio" name="eb-pdm" value="help"' + (state.rx.pdMode === 'help' ? ' checked' : '') + '> No PD?</label></div>' +
      (state.rx.pdMode === 'help' ? '<div class="eb-pd-help" data-eb-pd-help><button type="button" class="eb-pd-help__btn" data-eb-pd-measure>Measure PD</button><button type="button" class="eb-pd-help__btn" data-ebpd-open>PD Tools</button><button type="button" class="eb-pd-help__btn" data-eb-pd-need-help>Need Help</button></div>' : '') +
      (state.rx.pdHelp ? '<div class="eb-pd-helpnote">We will contact you for PD. You can continue.</div>' : '') +
      '<div data-eb-pdarea></div><div data-eb-frame-pd-warning></div><div class="eb-fielderr" data-err="pd" style="display:none"></div>';
  }
  function wirePdControls(el) {
    el.querySelectorAll('input[name=eb-pdm]').forEach(function (r) {
      r.onchange = function () {
        state.rx.pdMode = r.value;
        state.rx.pdHelp = false;
        if (r.value === 'help') {
          state.rx.pd = '';
          state.rx.pdR = '';
          state.rx.pdL = '';
        }
        render();
      };
    });
    var help = el.querySelector('[data-eb-pd-need-help]');
    if (help) help.onclick = function () {
      state.rx.pdHelp = true;
      state.rx.pd = '';
      state.rx.pdR = '';
      state.rx.pdL = '';
      render();
    };
    var measure = el.querySelector('[data-eb-pd-measure]');
    if (measure) measure.onclick = openPdMeasure;
  }
  function closePdMeasure() {
    var modal = document.querySelector('[data-eb-pd-modal]');
    if (modal) modal.hidden = true;
  }
  function openPdMeasure() {
    var modal = document.querySelector('[data-eb-pd-modal]');
    var body = modal && modal.querySelector('[data-eb-pd-modal-body]');
    if (!modal || !body) return;
    modal.hidden = false;
    body.innerHTML = '<div class="eb-pd-guide"><div class="eb-pd-print-card"><div><strong>Measure at home with our printable PD ruler</strong><span>Print at 100% actual size, then measure your child\'s pupillary distance.</span></div><a class="eb-pd-print-btn" href="https://cdn.shopify.com/s/files/1/0888/0590/0580/files/EyeBuddy-PD-Ruler.pdf?v=1788582307" target="_blank" rel="noopener">Print the PD Ruler</a></div><div class="eb-pd-guide__visual" aria-label="PD is measured from the center of one pupil to the center of the other" role="img"><svg viewBox="0 0 360 180" xmlns="http://www.w3.org/2000/svg"><rect x="28" y="124" width="304" height="22" rx="8" fill="#fff4ea" stroke="#f1d8c4"/><g stroke="#bf8d62" stroke-width="2"><path d="M54 124v18M84 124v10M114 124v18M144 124v10M174 124v18M204 124v10M234 124v18M264 124v10M294 124v18"/></g><path d="M71 78c25-27 68-27 93 0-25 25-68 25-93 0Z" fill="#fff" stroke="#2558d8" stroke-width="3"/><path d="M196 78c25-27 68-27 93 0-25 25-68 25-93 0Z" fill="#fff" stroke="#2558d8" stroke-width="3"/><circle cx="118" cy="78" r="14" fill="#2f2a26"/><circle cx="243" cy="78" r="14" fill="#2f2a26"/><circle cx="123" cy="73" r="4" fill="#fff"/><circle cx="248" cy="73" r="4" fill="#fff"/><path d="M118 104v18M243 104v18" stroke="#ff6b35" stroke-width="3" stroke-linecap="round"/><path d="M128 113h105" stroke="#ff6b35" stroke-width="4" stroke-linecap="round"/><path d="M129 113l10-8v16Z" fill="#ff6b35"/><path d="M232 113l-10-8v16Z" fill="#ff6b35"/><rect x="154" y="96" width="52" height="28" rx="14" fill="#ff6b35"/><text x="180" y="115" text-anchor="middle" fill="#fff" font-size="16" font-weight="800" font-family="Arial, sans-serif">PD</text></svg></div><p class="eb-pd-guide__lead">PD is the distance, in millimeters, between the centers of the pupils. It helps us center the lenses correctly.</p>' +
      '<div class="eb-pd-guide__steps"><div><b>1. Grab a millimeter ruler</b><p>Use a flat ruler with millimeter markings. Avoid flexible tape measures because they can bend and shift.</p></div>' +
      '<div><b>2. Keep the eyes level</b><p>Stand at arm&apos;s length facing your child. Ask them to look straight ahead at a small target at your eye level.</p></div>' +
      '<div><b>3. Measure pupil to pupil</b><p>Line up the 0 mm mark with the center of one pupil, then read the number at the center of the other pupil.</p></div></div>' +
      '<p class="eb-pd-guide__note">Measure 2-3 times in good lighting and use the average. If the prescription already includes PD, use that number. If you are not sure, choose <b>Need Help</b> and we will contact you before making the lenses.</p></div>';
  }
  function wireFile(el) {
    var fileInput = $('[data-eb-rxfile]'), btn = el.querySelector('[data-eb-attach]');
    if (!fileInput || !btn) return;
    function receiveFile(f) {
      if (!f) return;
      var err = el.querySelector('[data-eb-fileerr]');
      if (f.size > 10 * 1024 * 1024) {
        if (err) { err.textContent = 'File is over 10 MB. Please use a smaller photo or PDF.'; err.style.display = 'block'; }
        return;
      }
      if (!window.EyeBuddyRxOcr) {
        if (err) { err.textContent = 'The prescription scanner is unavailable. Please try again.'; err.style.display = 'block'; }
        return;
      }
      if (err) err.style.display = 'none';
      if (state.rx.previewUrl) URL.revokeObjectURL(state.rx.previewUrl);
      state.rx.file = f.name;
      state.rx.fileObject = f;
      state.rx.cartFileObject = f;
      state.rx.cartFilePromise = window.EyeBuddyRxOcr.prepareUploadFile
        ? window.EyeBuddyRxOcr.prepareUploadFile(f).then(function (prepared) {
          var uploadFile = prepared || f;
          if (state.rx.fileObject === f) state.rx.cartFileObject = uploadFile;
          return uploadFile;
        }).catch(function () {
          if (state.rx.fileObject === f) state.rx.cartFileObject = f;
          return f;
        })
        : Promise.resolve(f);
      state.rx.previewUrl = URL.createObjectURL(f);
      state.rx.previewType = f.type || '';
      state.rx.ocrStage = 'scanning';
      state.rx.ocrProgress = 0;
      state.rx.ocrError = '';
      state.rx.ocrMissing = [];
      render();
      window.EyeBuddyRxOcr.scan(f, {
        needsAdd: needsAdd(),
        endpoint: CFG.ocrEndpoint || (location.hostname === '127.0.0.1' || location.hostname === 'localhost' ? 'http://127.0.0.1:8787/rx-scan' : ''),
        progress: function (update) {
          state.rx.ocrProgress = Math.max(state.rx.ocrProgress, Number(update.progress || 0));
          var meter = root.querySelector('.eb-ocr-meter i');
          if (meter) meter.style.width = Math.round(state.rx.ocrProgress * 100) + '%';
        }
      }).then(function (result) {
        if (!result || result.kind === 'allError') {
          state.rx.ocrStage = 'error';
          state.rx.ocrError = 'We could not read the prescription clearly. Please use a sharper, well-lit image.';
          render();
          return;
        }
        applyOcrResult(result);
        state.materialGroup = null;
        state.material = null;
        state.materialConfirmId = null;
        render();
      }).catch(function (error) {
        console.error('[eb-rxflow] prescription scan failed:', error);
        state.rx.ocrStage = 'error';
        state.rx.ocrError = error && error.message ? error.message : 'We could not scan this file. Please try another image or PDF.';
        render();
      });
    }
    btn.onclick = function () {
      // Mobile Safari can drop change events from detached, temporary file inputs.
      // Reuse the persistent input inside the form and reset it so selecting the
      // same file again still fires change.
      fileInput.value = '';
      fileInput.click();
    };
    fileInput.onchange = function (e) { receiveFile(e.target.files && e.target.files[0]); };
    var zoom = el.querySelector('[data-eb-ocr-zoom]');
    var lightbox = el.querySelector('[data-eb-ocr-lightbox]');
    var lightboxClose = el.querySelector('[data-eb-ocr-lightbox-close]');
    function closeLightbox() {
      if (!lightbox) return;
      if (typeof lightbox.close === 'function' && lightbox.open) lightbox.close();
      else lightbox.removeAttribute('open');
    }
    if (zoom && lightbox) zoom.onclick = function () {
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
    };
    if (lightboxClose) lightboxClose.onclick = closeLightbox;
    if (lightbox) lightbox.onclick = function (e) { if (e.target === lightbox) closeLightbox(); };
  }
  function renderRx(el) {
    var R = CFG.ranges;
    var uploadReview = state.method === 'upload' && state.rx.ocrStage === 'review';
    if (state.method === 'upload' && !uploadReview) {
      el.innerHTML = '<h2>Upload Prescription</h2><p class="eb-hint eb-step-hint">Upload a clear photo or PDF. We will scan the values for you.</p>' + uploadScannerHtml();
      wireFile(el); syncNext(); return;
    }
    var stash = state.method === 'manual' && (!state.rxStashDismissed && !state.added) ? rxStashLoad() : null;
    el.innerHTML = '<h2>' + (uploadReview ? 'Review the Prescription' : 'Enter the Prescription') + '</h2>' +
      (uploadReview ? ocrReviewHtml() : '') +
      (stash ? '<div class="eb-rxreuse" data-eb-rxreuse><p class="eb-rxreuse__title">Use the prescription you just entered?</p><p class="eb-rxreuse__vals">' + esc(rxStashSummary(stash)) +
        '</p><button type="button" class="eb-cta eb-rxreuse__use" data-eb-rxreuse-use>Use this prescription</button><button type="button" class="eb-skiplink" data-eb-rxreuse-no>Enter a different one</button></div>' : '') +
      eyeBlock('od', 'OD (Right Eye)') + eyeBlock('os', 'OS (Left Eye)') +
      '<hr class="eb-sep">' + pdChooserHtml() +
      '<hr class="eb-sep"><div class="eb-prism-head"><h3 class="eb-pdtitle">Prism Values</h3><span class="eb-prism-price">+' + money(prismFeePrice()) + '</span></div>' +
      '<div class="eb-pdrow eb-prism-toggle"><label><input type="radio" name="eb-prism-toggle" value="no"' + (!state.rx.hasPrism ? ' checked' : '') + '> No</label><label><input type="radio" name="eb-prism-toggle" value="yes"' + (state.rx.hasPrism ? ' checked' : '') + '> Yes</label></div>' +
      (state.rx.hasPrism ? '<p class="eb-hint">Enter prism values exactly as written on the prescription. Some prism prescriptions may require manual review.</p>' + prismBlock('od', 'OD (Right Eye)') + prismBlock('os', 'OS (Left Eye)') : '');
    el.querySelectorAll('select[data-eye]').forEach(function (s) {
      var eye = s.dataset.eye, f = s.dataset.f, v = state.rx[eye][f];
      if (f === 'sph') opts(s, parseFloat(R.sphMin == null ? -15 : R.sphMin), parseFloat(R.sphMax == null ? 12 : R.sphMax), R.step, fmtP, v, uploadReview);
      if (f === 'cyl') opts(s, parseFloat(R.cylMin), (R.cylMax == null ? 6 : parseFloat(R.cylMax)), R.step, fmtP, v, uploadReview);
      if (f === 'axis') { opts(s, 1, 180, 1, function (x) { return x; }, v, true); s.disabled = parseFloat(state.rx[eye].cyl) === 0; }
      if (f === 'add') opts(s, Math.min(0, parseFloat(R.addMin == null ? 0 : R.addMin)), parseFloat(R.addMax == null ? 4 : R.addMax), R.step, fmtP, Number.isFinite(parseFloat(v)) ? parseFloat(v).toFixed(2) : '', true);
      s.onchange = function () {
        state.rx[eye][f] = s.value; state.materialGroup = null; state.material = null;
        state.rx.ocrMissing = (state.rx.ocrMissing || []).filter(function (field) { return field !== eye + '.' + f; });
        if (s.parentElement) s.parentElement.classList.remove('eb-ocr-field--missing');
        if (f === 'cyl') { if (parseFloat(s.value) === 0) state.rx[eye].axis = ''; render(); } else validateRx(el);
        syncNext();
      };
    });
    wirePdControls(el);
    el.querySelectorAll('input[name=eb-prism-toggle]').forEach(function (r) {
      r.onchange = function () { state.rx.hasPrism = r.value === 'yes'; if (!state.rx.hasPrism) clearPrismValues(); render(); };
    });
    el.querySelectorAll('[data-prism-eye]').forEach(function (s) {
      var eye = s.dataset.prismEye, f = s.dataset.prismF, v = state.rx[eye][f];
      if (f === 'prismH' || f === 'prismV') opts(s, 0, parseFloat(R.prismMax == null ? 10 : R.prismMax), R.step, function (x) { return x; }, v, true);
      if (f === 'baseH') directionOpts(s, ['IN', 'OUT'], v);
      if (f === 'baseV') directionOpts(s, ['UP', 'DOWN'], v);
      s.onchange = function () {
        state.rx[eye][f] = s.value;
        if (f === 'prismH' && (!s.value || parseFloat(s.value) === 0)) state.rx[eye].baseH = '';
        if (f === 'prismV' && (!s.value || parseFloat(s.value) === 0)) state.rx[eye].baseV = '';
        validateRx(el); syncNext();
      };
    });
    var useBtn = el.querySelector('[data-eb-rxreuse-use]');
    if (useBtn) useBtn.onclick = function () {
      var sv = rxStashLoad(); state.rxStashDismissed = true;
      if (sv) {
        state.rx.od = restoreEye(sv.od); state.rx.os = restoreEye(sv.os);
        state.rx.hasPrism = sv.hasPrism === true || !!(prismString(state.rx.od) || prismString(state.rx.os));
        state.rx.pdMode = sv.pdMode === 'dual' ? 'dual' : sv.pdMode === 'help' ? 'help' : 'single';
        state.rx.pd = sv.pd || ''; state.rx.pdR = sv.pdR || ''; state.rx.pdL = sv.pdL || ''; state.rx.pdHelp = sv.pdHelp === true;
        state.materialGroup = null; state.material = null;
      }
      render();
    };
    var noBtn = el.querySelector('[data-eb-rxreuse-no]');
    if (noBtn) noBtn.onclick = function () { state.rxStashDismissed = true; render(); };
    if (uploadReview) {
      wireFile(el);
      (state.rx.ocrMissing || []).forEach(function (field) {
        if (field === 'pd') return;
        var parts = field.split('.');
        var select = el.querySelector('[data-eye="' + parts[0] + '"][data-f="' + parts[1] + '"]');
        if (select && select.parentElement) select.parentElement.classList.add('eb-ocr-field--missing');
      });
    }
    renderPd(el); validateRx(el); syncNext();
  }
  function renderPd(el) {
    var a = el.querySelector('[data-eb-pdarea]'), R = CFG.ranges;
    if (!a) return;
    if (state.rx.pdMode === 'help') {
      a.innerHTML = '';
      return;
    }
    if (state.rx.pdMode === 'single') {
      a.innerHTML = '<div style="max-width:220px"><label class="eb-f">PD</label><select data-eb-pd1></select></div>';
      var s = a.querySelector('[data-eb-pd1]');
      opts(s, parseFloat(R.pdMin), parseFloat(R.pdMax), R.pdStep, function (x) { return x; }, state.rx.pd, true);
      s.onchange = function (e) { state.rx.pd = e.target.value; state.rx.ocrMissing = (state.rx.ocrMissing || []).filter(function (field) { return field !== 'pd'; }); renderFramePdWarning(el); validateRx(el); syncNext(); };
    } else {
      a.innerHTML = '<div class="eb-grid3" style="grid-template-columns:1fr 1fr;max-width:340px"><div><label class="eb-f">Right (OD)</label><select data-eb-pdr></select></div><div><label class="eb-f">Left (OS)</label><select data-eb-pdl></select></div></div>';
      var r = a.querySelector('[data-eb-pdr]'), l = a.querySelector('[data-eb-pdl]');
      opts(r, parseFloat(R.dpdMin), parseFloat(R.dpdMax), R.pdStep, function (x) { return x; }, state.rx.pdR, true);
      opts(l, parseFloat(R.dpdMin), parseFloat(R.dpdMax), R.pdStep, function (x) { return x; }, state.rx.pdL, true);
      r.onchange = function (e) { state.rx.pdR = e.target.value; state.rx.ocrMissing = (state.rx.ocrMissing || []).filter(function (field) { return field !== 'pd'; }); renderFramePdWarning(el); validateRx(el); syncNext(); };
      l.onchange = function (e) { state.rx.pdL = e.target.value; state.rx.ocrMissing = (state.rx.ocrMissing || []).filter(function (field) { return field !== 'pd'; }); renderFramePdWarning(el); validateRx(el); syncNext(); };
    }
    renderFramePdWarning(el);
  }
  function rxProblems() {
    var p = {};
    addPdProblems(p);
    if (state.method === 'upload') {
      if (!state.rx.file) p.file = 'Please upload the prescription file.';
      else if (state.rx.ocrStage !== 'review') p.file = 'Please wait for the prescription scan to finish.';
    }
    if (state.method !== 'manual' && state.method !== 'upload') return p;
    ['od', 'os'].forEach(function (eye) {
      var e = state.rx[eye], cyl = parseFloat(e.cyl) || 0, add = parseFloat(e.add);
      var eyeIssues = [];
      if (e.sph === '') eyeIssues.push('Choose SPH.');
      if (e.cyl === '') eyeIssues.push('Choose CYL.');
      if (e.cyl !== '' && cyl !== 0 && !e.axis) eyeIssues.push('AXIS is required when CYL is not 0.00.');
      if (needsAdd() && !Number.isFinite(add)) eyeIssues.push('Choose ADD for this eye. Select 0.00 if the prescription specifies no ADD.');
      else if (needsAdd() && add < 0) eyeIssues.push('ADD must be 0.00 or a positive value.');
      else if (needsAdd() && add === 0 && parseFloat(state.rx[eye === 'od' ? 'os' : 'od'].add) === 0) {
        eyeIssues.push('Both ADD values are 0.00. Please check your prescription and lens type, or contact us for help.');
      }
      if (eyeIssues.length) p[eye] = eyeIssues.join(' ');
      if (!state.rx.hasPrism) return;
      var prismIssues = [];
      if (parseFloat(e.prismH) > 0 && !e.baseH) prismIssues.push('Choose horizontal base direction.');
      if (e.baseH && !(parseFloat(e.prismH) > 0)) prismIssues.push('Choose a horizontal prism amount.');
      if (parseFloat(e.prismV) > 0 && !e.baseV) prismIssues.push('Choose vertical base direction.');
      if (e.baseV && !(parseFloat(e.prismV) > 0)) prismIssues.push('Choose a vertical prism amount.');
      if (prismIssues.length) p[eye + 'Prism'] = prismIssues.join(' ');
    });
    if (state.rx.hasPrism && !hasPrismValues()) p.prism = 'Please enter at least one prism value, or choose No.';
    return p;
  }
  function addPdProblems(p) {
    if (state.method !== 'manual' && state.method !== 'upload') return;
    if (state.rx.pdMode === 'help') {
      if (!state.rx.pdHelp) p.pd = 'Please choose Measure PD or Need Help.';
      return;
    }
    if (state.rx.pdMode === 'single') { if (!state.rx.pd) p.pd = 'Please choose a PD.'; }
    else if (!state.rx.pdR || !state.rx.pdL) p.pd = 'Please choose both PD values.';
    else if (Math.abs(parseFloat(state.rx.pdR) - parseFloat(state.rx.pdL)) > 4) p.pdWarn = 'Right and left PD differ by more than 4 mm. Please double-check.';
  }
  function validateRx(el) {
    var p = rxProblems();
    var fileErr = el.querySelector('[data-eb-fileerr]');
    if (fileErr && p.file) { fileErr.style.display = 'block'; fileErr.textContent = p.file; }
    ['od', 'os'].forEach(function (eye) {
      var box = el.querySelector('[data-err="' + eye + '"]');
      if (box) { box.style.display = p[eye] ? 'block' : 'none'; box.textContent = p[eye] || ''; }
      var prismBox = el.querySelector('[data-err="' + eye + '-prism"]');
      if (prismBox) { prismBox.style.display = p[eye + 'Prism'] || p.prism ? 'block' : 'none'; prismBox.textContent = p[eye + 'Prism'] || p.prism || ''; }
    });
    var pd = el.querySelector('[data-err="pd"]');
    if (pd) {
      if (p.pd) { pd.style.display = 'block'; pd.className = 'eb-fielderr'; pd.textContent = p.pd; }
      else if (p.pdWarn) { pd.style.display = 'block'; pd.className = 'eb-fieldwarn'; pd.textContent = p.pdWarn; }
      else pd.style.display = 'none';
    }
  }
  function rxValid() {
    var p = rxProblems();
    if (p.od || p.os || p.odPrism || p.osPrism || p.prism || p.pd || p.file) return false;
    return true;
  }
  function renderMaterial(el) {
    var groups = materialGroups();
    var availabilityNote = state.type === 'multifocal' ? 'Trivex is not available for multifocal lenses.' : state.lensOption === 'blue' ? 'Trivex is not available with Blue Light.' : '';
    if (!state.materialGroup || !groups.some(function (g) { return g.id === state.materialGroup; })) {
      el.innerHTML = '<h2>Choose Lens Material</h2><p class="eb-hint eb-step-hint">Choose a material first. The next screen shows the available prescription tiers and prices.</p>' +
        (availabilityNote ? '<p class="eb-hint eb-step-hint" role="note">' + esc(availabilityNote) + '</p>' : '') +
        groups.map(function (g) { return choice(g, state.materialGroup === g.id, false, ''); }).join('');
      el.querySelectorAll('.eb-choice').forEach(function (b) {
        b.onclick = function () { state.materialGroup = b.dataset.k; state.material = null; state.materialConfirmId = null; renderMaterial(el); syncSummary(); syncNext(); resetStepScroll(); };
      });
      wireImagePreviews(el);
      return;
    }
    var list = materialList().filter(function (m) { return m.group === state.materialGroup; }).map(function (m) {
      var label = m.t;
      var sphMin = Number(m.sphMin == null ? -Math.abs(Number(m.sph || 0)) : m.sphMin);
      var sphMax = Number(m.sphMax == null ? Math.abs(Number(m.sph || 0)) : m.sphMax);
      var cylMin = Number(m.cylMin == null ? -Math.abs(Number(m.cyl || 0)) : m.cylMin);
      var cylMax = Number(m.cylMax == null ? Math.abs(Number(m.cyl || 0)) : m.cylMax);
      return Object.assign({}, m, { t: label, ic: materialTierIcon(m), range: 'SPH ' + fmtRange(sphMin, sphMax, true) + ', CYL ' + fmtRange(cylMin, cylMax, false) });
    });
    renderChoices(el, state.materialGroup, 'Choose the tier that matches the prescription. We check plus-cylinder prescriptions after converting them to lab-ready minus-cylinder form.', list, state.material, function (k) {
      var selectedMaterial = materialList().find(function (m) { return m.id === k; });
      if (materialConfirmation(selectedMaterial)) {
        state.material = null;
        state.materialConfirmId = k;
        renderMaterial(el);
        return false;
      }
      state.materialConfirmId = null;
      state.material = k;
    }, materialCompatible);
    if (availabilityNote) el.querySelector('h2').insertAdjacentHTML('afterend', '<p class="eb-hint eb-step-hint" role="note">' + esc(availabilityNote) + '</p>');
    if (state.materialConfirmId) {
      var pendingMaterial = materialList().find(function (m) { return m.id === state.materialConfirmId; });
      var pendingConfirmation = materialConfirmation(pendingMaterial);
      var pendingCard = el.querySelector('.eb-choice[data-k="' + state.materialConfirmId + '"]');
      if (pendingCard && pendingConfirmation) {
        pendingCard.insertAdjacentHTML('afterend', '<div class="eb-standard-eligibility"><p class="eb-hint">' + esc(pendingConfirmation.message) + '</p><button type="button" class="eb-cta" data-eb-material-confirm>Confirm and continue</button></div>');
        el.querySelector('[data-eb-material-confirm]').onclick = function () {
          state.material = state.materialConfirmId;
          state.materialConfirmId = null;
          advance();
        };
      }
    }
    el.insertAdjacentHTML('beforeend', '<p class="eb-material-help">Can&apos;t choose a lens or have a special request? Contact <a href="mailto:hi@eyebuddykids.com">hi@eyebuddykids.com</a>.</p>');
  }
  function renderAddons(el) {
    el.innerHTML = '<h2>Complete the Pair</h2><p class="eb-hint eb-step-hint">Optional extras.</p>' +
      CFG.addons.map(function (a) {
        var on = state.addons.indexOf(a.id) !== -1;
        var hasPrice = Number(a.price) > 0;
        return '<button type="button" class="eb-choice' + (hasPrice ? '' : ' eb-choice--noprice') + (on ? ' eb-choice--selected' : '') + '" data-k="' + esc(a.id) + '"><span class="eb-check">' + (on ? '✓' : '') + '</span><span><div class="eb-t">' + esc(a.name) + '</div><div class="eb-d">' + esc(a.desc || '') + '</div></span>' + (hasPrice ? '<span class="eb-price">' + money(a.price) + '</span>' : '') + '</button>';
      }).join('') + '<button type="button" class="eb-skiplink" data-eb-skip>No thanks, continue without extras</button>';
    el.querySelectorAll('.eb-choice').forEach(function (b) {
      b.onclick = function () {
        var k = b.dataset.k;
        state.addons = state.addons.indexOf(k) !== -1 ? state.addons.filter(function (x) { return x !== k; }) : state.addons.concat([k]);
        renderAddons(el); syncSummary(); syncNext();
      };
    });
    el.querySelector('[data-eb-skip]').onclick = function () { state.addons = []; advance(); };
  }
  function pdString() { return state.rx.pdHelp ? 'Customer needs help - contact before production' : state.rx.pdMode === 'single' ? 'Single | ' + state.rx.pd : 'Dual | R ' + state.rx.pdR + ' / L ' + state.rx.pdL; }
  function eyeString(eye) {
    var e = state.rx[eye], ax = parseFloat(e.cyl) !== 0 ? ' | x' + String(e.axis).padStart(3, '0') : '';
    var add = needsAdd() && Number.isFinite(parseFloat(e.add)) ? ' | ADD ' + fmtP(e.add) : '';
    return fmtP(e.sph) + ' | ' + fmtP(e.cyl) + ax + add;
  }
  function labEyeString(eye) {
    var n = normalizeEye(state.rx[eye]), ax = n.cyl !== 0 && n.axis ? ' | x' + String(n.axis).padStart(3, '0') : '';
    return fmtP(n.sph) + ' | ' + fmtP(n.cyl) + ax;
  }
  function renderReview(el) {
    var v = currentVariant(), comps = componentList(), adds = chosenAddons(), rxHtml = '';
    var verificationHtml = complexLensNeedsReview() ? '<div class="eb-confirmbox"><span><b>Manual review required</b><br>This lens can be made, but it is more complex and requires manual review. We will contact you if any changes are needed.</span></div>' : '';
    var colorHtml = state.lensOption === 'sun' && selectedSunColor() ? '<div class="eb-row"><span class="eb-muted">Lens Color</span><b>' + esc(selectedSunColor().t) + '</b></div>' : '';
    if (needsRx()) {
      rxHtml += '<div class="eb-row"><span class="eb-muted">Method</span><b>' + esc(frameMethod()) + '</b></div>';
      if (state.method === 'manual' || state.method === 'upload') {
        rxHtml += '<div class="eb-row"><span class="eb-muted">OD (Right)</span><b>' + esc(eyeString('od')) + '</b></div><div class="eb-row"><span class="eb-muted">OS (Left)</span><b>' + esc(eyeString('os')) + '</b></div><div class="eb-row"><span class="eb-muted">PD</span><b>' + esc(pdString()) + '</b></div>';
        if (state.rx.hasPrism && eyePrismString('od')) rxHtml += '<div class="eb-row"><span class="eb-muted">OD Prism</span><b>' + esc(eyePrismString('od')) + '</b></div>';
        if (state.rx.hasPrism && eyePrismString('os')) rxHtml += '<div class="eb-row"><span class="eb-muted">OS Prism</span><b>' + esc(eyePrismString('os')) + '</b></div>';
      }
    }
    if (state.rx.file) rxHtml += '<div class="eb-row"><span class="eb-muted">Rx file</span><b>' + esc(state.rx.file) + '</b></div>';
    el.innerHTML = '<h2>Please Review the Order</h2><div class="eb-rev"><div class="eb-row"><b>' + esc(frameName(v)) + '</b><b>' + money(v.price) + '</b></div><div class="eb-row"><span class="eb-muted">Lens</span><b>' + esc(lensLabel()) + '</b></div>' +
      colorHtml +
      comps.map(function (c) { return '<div class="eb-row"><span class="eb-muted">' + esc(c.kind) + '</span><b>' + esc(c.name) + ' / ' + money(c.price) + '</b></div>'; }).join('') +
      (chargePrism() ? '<div class="eb-row"><span class="eb-muted">Prism Correction</span><b>' + money(prismFeePrice()) + '</b></div>' : '') +
      adds.map(function (a) { return '<div class="eb-row"><span class="eb-muted">Add-on</span><b>' + esc(a.name) + (Number(a.price) > 0 ? ' / ' + money(a.price) : '') + '</b></div>'; }).join('') + rxHtml + verificationHtml + '</div>' +
      '<div class="eb-rev"><label class="eb-f" for="eb-forname">Who are these for? (first name, optional)</label><input type="text" id="eb-forname" maxlength="40" placeholder="e.g. Mia" value="' + esc(state.forName) + '"><label class="eb-f" for="eb-birthyear" style="margin-top:12px">Birth year (for fit check) · Recommended</label><select id="eb-birthyear">' + birthYearOptions() + '</select></div><div class="eb-rev"><label class="eb-f" for="eb-notes">Order notes</label><textarea id="eb-notes" rows="2" placeholder="Anything we should know?">' + esc(state.notes) + '</textarea></div><div data-eb-done style="display:none"></div>';
    el.querySelector('#eb-forname').oninput = function (e) { state.forName = e.target.value; };
    el.querySelector('#eb-birthyear').onchange = function (e) { state.birthYear = e.target.value; };
    el.querySelector('#eb-notes').oninput = function (e) { state.notes = e.target.value; };
    if (state.added) renderSuccess();
  }
  function buildItems(pairId) {
    var v = currentVariant();
    if (needsMaterial() && (!selectedMaterial() || !(Number(selectedMaterial().price) > 0) || !selectedMaterial().variantId)) {
      throw new Error('Please select a priced lens material before adding this pair.');
    }
    if (needsMaterial()) {
      var compatibility = materialCompatible(selectedMaterial());
      if (!compatibility.ok) throw new Error(compatibility.why);
    }
    var frameProps = { 'Prescription Type': typeLabel(), 'Lens': lensLabel(), '_pair_id': pairId };
    if (state.lensOption === 'sun' && selectedSun()) frameProps['Sunglasses Style'] = selectedSun().t;
    if (state.lensOption === 'sun' && selectedSunColor()) frameProps['Lens Color'] = selectedSunColor().t;
    if (needsRx()) {
      frameProps.Method = frameMethod();
      frameProps.PD = orderPdString();
      if (state.method === 'manual' || state.method === 'upload') {
        frameProps['OD (Right)'] = eyeString('od'); frameProps['OS (Left)'] = eyeString('os');
        frameProps['Lab OD (minus cyl)'] = labEyeString('od'); frameProps['Lab OS (minus cyl)'] = labEyeString('os');
        if (state.rx.hasPrism) frameProps['Prism Values'] = 'Yes';
        if (state.rx.hasPrism && eyePrismString('od')) frameProps['OD Prism'] = eyePrismString('od');
        if (state.rx.hasPrism && eyePrismString('os')) frameProps['OS Prism'] = eyePrismString('os');
      }
    }
    if (complexLensNeedsReview()) frameProps['Complex Lens Review'] = 'Manual review required before production';
    if (state.forName) frameProps.For = state.forName;
    if (state.birthYear) frameProps['Birth Year'] = birthYearOrderString();
    if (state.notes) frameProps['Order Notes'] = state.notes;
    var items = [{ id: v.id, quantity: 1, properties: frameProps }];
    componentList().forEach(function (c) {
      var props = { '_pair_id': pairId, Frame: frameName(v), Service: c.kind, 'Lens Choice': c.name };
      if (c.kind === 'Sunglasses' && selectedSunColor()) props['Lens Color'] = selectedSunColor().t;
      if (c.kind === 'Lens Material' && complexLensNeedsReview()) props['Complex Lens Review'] = 'Manual review required before production';
      items.push({ id: c.variantId, quantity: 1, properties: props });
    });
    if (chargePrism() && prismFeeVariantId()) items.push({ id: prismFeeVariantId(), quantity: 1, properties: { '_pair_id': pairId, Frame: frameName(v), Service: 'Prism Correction' } });
    chosenAddons().forEach(function (a) { items.push({ id: Number(a.variantId), quantity: 1, properties: { '_pair_id': pairId, Frame: frameName(v) } }); });
    frameProps._eb_required_components = JSON.stringify(items.slice(1).map(function (item) { return { id: Number(item.id), quantity: item.quantity }; }));
    return items;
  }
  function pairSubtotal() {
    var v = currentVariant();
    return Number(v.price) + componentList().reduce(function (s, c) { return s + Number(c.price); }, 0) + chosenAddons().reduce(function (s, a) { return s + Number(a.price); }, 0) + (chargePrism() ? prismFeePrice() : 0);
  }
  function syncSummary() {
    var v = currentVariant(), comps = componentList(), adds = chosenAddons();
    $('[data-eb-sumframe]').textContent = money(v.price);
    $('[data-eb-lensrow]').style.display = comps.length ? 'flex' : 'none';
    if (comps.length) $('[data-eb-sumlens]').textContent = money(comps.reduce(function (s, c) { return s + Number(c.price); }, 0));
    var prismRow = $('[data-eb-prismrow]');
    if (prismRow) { prismRow.style.display = chargePrism() ? 'flex' : 'none'; $('[data-eb-sumprism]').textContent = money(prismFeePrice()); }
    var addSum = adds.reduce(function (s, a) { return s + Number(a.price); }, 0);
    $('[data-eb-addonrow]').style.display = addSum > 0 ? 'flex' : 'none';
    if (addSum > 0) $('[data-eb-sumaddons]').textContent = money(addSum);
    $('[data-eb-sumtotal]').textContent = money(pairSubtotal());
  }
  function syncCartRow() {}
  function canContinue() {
    if (state.busy) return false;
    switch (cur()) {
      case 'type': return !!state.type;
      case 'multitype': return !!state.multiType;
      case 'lens': return state.type === 'multifocal' ? !!state.multiOption : !!state.lensOption;
      case 'sun': return !!state.sunStyle;
      case 'suncolor': return !!state.sunColor;
      case 'method': return !!state.method;
      case 'rx': return rxValid();
      case 'material': return !!state.material && materialCompatible(selectedMaterial()).ok;
      case 'addons': return true;
      case 'review': return !state.added;
    }
    return false;
  }
  function syncNext() {
    var n = $('[data-eb-next]');
    n.disabled = state.busy || !canContinue();
    n.textContent = state.busy ? (state.rx.file ? 'Uploading prescription...' : 'Adding...') : state.added ? 'Added to cart' : cur() === 'review' ? 'Add to Cart' : 'Continue';
  }
  function rxFileObj() {
    var inp = $('[data-eb-rxfile]');
    return state.rx.cartFileObject || state.rx.fileObject || (inp && inp.files && inp.files[0] ? inp.files[0] : null);
  }
  function addToCart() {
    if (state.busy || state.added) return;
    var pairId = 'eb-' + Date.now(), items, fileReady = state.rx.cartFilePromise || Promise.resolve(rxFileObj()), errBox = $('[data-eb-adderror]');
    if (errBox) { errBox.style.display = 'none'; errBox.textContent = ''; }
    state.busy = true; window.__ebPairAddPending = true; syncNext();
    function done() { state.busy = false; window.__ebPairAddPending = false; state.added = true; if (state.method === 'manual' || state.method === 'upload') rxStashSave(); syncNext(); renderSuccess(); toast('Pair added'); }
    function fail(err) {
      console.error('[eb-rxflow] add to cart failed:', err); state.busy = false; window.__ebPairAddPending = false; syncNext();
      var box = $('[data-eb-adderror]');
      if (box) {
        box.textContent = err && err.message ? err.message : 'Something went wrong adding this to the cart. Please try again or contact us.';
        box.style.display = 'block';
      }
      toast('Could not add to cart');
    }
    try {
      if (needsRx() && (state.method === 'manual' || state.method === 'upload') && !rxValid()) throw new Error('Please review the prescription before adding this pair.');
      items = buildItems(pairId);
    } catch (error) { fail(error); return; }
    function verifyAddedPair() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) {
        if (!r.ok) throw new Error('We could not verify the complete pair. Please review your cart.');
        return r.json();
      }).then(function (cart) {
        var actual = cart.items.filter(function (item) { return item.properties && item.properties._pair_id === pairId; });
        if (actual.length !== items.length || items.some(function (expected) {
          return !actual.some(function (item) {
            return Number(item.variant_id || item.id) === Number(expected.id) && item.quantity === expected.quantity &&
              Object.keys(expected.properties).every(function (key) { return String(item.properties[key]) === String(expected.properties[key]); });
          });
        })) throw new Error('The complete frame and lenses were not added. Please review your cart and try again.');
        if (window.EBPairGuard) window.EBPairGuard.validate({ items: actual });
      });
    }
    function addJson(list) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list }) }).then(function (r) {
        if (!r.ok) return r.json().catch(function () { return {}; }).then(function (j) { throw new Error(j.description || ('HTTP ' + r.status)); });
        return r.json();
      });
    }
    Promise.resolve(fileReady).then(function (file) {
      file = file || rxFileObj();
      if (!file) return addJson(items);
      var frame = items[0], fd = new FormData();
      fd.append('id', String(frame.id)); fd.append('quantity', '1');
      Object.keys(frame.properties).forEach(function (k) { fd.append('properties[' + k + ']', frame.properties[k]); });
      fd.append('properties[Rx File]', file, file.name);
      return fetch('/cart/add.js', { method: 'POST', body: fd }).then(function (r) {
        if (!r.ok) return r.text().then(function (t) { throw new Error('multipart add failed: ' + t.slice(0, 200)); });
        return r.json();
      }).then(function () {
        return items.length > 1 ? addJson(items.slice(1)) : null;
      });
    }).then(verifyAddedPair).then(done).catch(function (err) {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) {
        if (!r.ok) throw err;
        return r.json();
      }).then(function (cart) {
        var updates = {};
        cart.items.forEach(function (item) { if (item.properties && item.properties._pair_id === pairId) updates[item.key] = 0; });
        if (!Object.keys(updates).length) return;
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) }).then(function (r) { if (!r.ok) throw err; });
      }).then(function () { fail(err); }).catch(function () {
        fail(new Error('We could not verify or remove the incomplete pair. Do not check out; remove this pair from your cart and try again, or contact hi@eyebuddykids.com.'));
      });
    });
  }
  function renderSuccess() {
    var d = $('[data-eb-done]'); if (!d) return;
    d.style.display = 'block';
    d.innerHTML = '<div class="eb-confirmbox eb-confirmbox--good"><span><b>Pair added to cart!</b></span></div><a class="eb-cta" style="display:block;text-align:center;text-decoration:none" href="/cart">Review cart</a><a class="eb-ghost" href="' + esc(CFG.urls.secondPair) + '">' + esc(CFG.copy.secondPairLabel || 'Add another pair') + '</a>';
    d.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  $('[data-eb-form]').addEventListener('submit', function (e) { e.preventDefault(); });
  $('[data-eb-next]').addEventListener('click', function () { if (state.busy || !canContinue()) return; if (cur() === 'review') addToCart(); else advance(); });
  $('[data-eb-back]').addEventListener('click', function () {
    if (state.added) return;
    if (cur() === 'material' && state.materialGroup) {
      state.materialGroup = null;
      state.material = null;
      state.materialConfirmId = null;
      render();
      resetStepScroll();
      return;
    }
    if (stepIdx > 0) { stepIdx--; render(); resetStepScroll(); }
  });

  var panel = $('[data-eb-panel]'), scrim = $('[data-eb-scrim]'), closeBtn = $('[data-eb-close]');
  var lastFocus = null, keyHandler = null, hideTimer = null;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-eb-pd-modal-close]').forEach(function (btn) {
    btn.addEventListener('click', closePdMeasure);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePdMeasure();
  });
  function panelFocusables() {
    if (!panel) return [];
    return Array.prototype.filter.call(panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]):not([data-eb-enhanced]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'), function (el) { return el.offsetParent !== null; });
  }
  function onPanelKey(e) {
    if (e.key === 'Escape') {
      if (root.querySelector('.eb-select--open')) { e.preventDefault(); closeSelectMenus(); return; }
      e.preventDefault(); closePanel(); return;
    }
    if (e.key === 'Tab') {
      var f = panelFocusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  // Speedy requires explicit acknowledgement on each entry into the lens wizard.
  var speedyNotice = null;
  function showSpeedyNotice() {
    if (!speedyNotice) {
      var style = document.createElement('style');
      style.textContent = '.eb-speedy-notice{position:fixed;inset:0;box-sizing:border-box;width:calc(100% - 32px);max-width:440px;max-height:calc(100dvh - 40px);margin:auto;padding:28px;border:1px solid #eadfce;border-radius:22px;background:#fffaf3;color:#302821;font-family:inherit;box-shadow:0 20px 70px #30282126;overflow:auto;text-align:left}.eb-speedy-notice::backdrop{background:rgba(34,29,24,.45)}.eb-speedy-notice h2{margin:0 26px 14px 0;font-weight:800;font-size:25px;line-height:1.2}.eb-speedy-notice p{margin:0 0 16px;font-size:15px;line-height:1.6}.eb-speedy-notice .eb-speedy-range{display:block;padding:14px 16px;border-radius:12px;background:#fff0df;color:#a64316;font-size:21px;font-weight:800;text-align:center}.eb-speedy-notice a{color:#302821;text-decoration:underline}.eb-speedy-notice-actions{display:flex;gap:10px;margin-top:22px}.eb-speedy-notice button{appearance:none;box-sizing:border-box;min-height:46px;border:1px solid #dfd2c1;border-radius:999px;padding:10px 18px;font-family:inherit;font-size:15px;font-weight:700;cursor:pointer;background:#fff;color:#514335}.eb-speedy-notice button[data-speedy-yes]{flex:1;background:#ff682d;border-color:#ff682d;color:#fff}.eb-speedy-notice .eb-speedy-close{position:absolute;top:13px;right:13px;min-height:36px;width:36px;padding:0;border:0;background:transparent;font-size:25px;font-weight:400}.eb-speedy-notice button:focus-visible{outline:2px solid #245de9;outline-offset:3px}@media(max-width:480px){.eb-speedy-notice{padding:24px}.eb-speedy-notice h2{font-size:23px}}';
      document.head.appendChild(style);
      speedyNotice = document.createElement('dialog');
      speedyNotice.className = 'eb-speedy-notice';
      speedyNotice.setAttribute('aria-labelledby', 'eb-speedy-notice-title');
      speedyNotice.setAttribute('aria-describedby', 'eb-speedy-notice-copy');
      speedyNotice.innerHTML = '<button type="button" class="eb-speedy-close" aria-label="Close prescription notice">×</button><h2 id="eb-speedy-notice-title">Before you choose lenses</h2><p id="eb-speedy-notice-copy" style="color:#d9480f;font-weight:700">This frame requires specially shaped, curved lenses. If your prescription is outside our manufacturing range, we will contact you.</p><p>Questions? Contact <a href="mailto:hi@eyebuddykids.com">hi@eyebuddykids.com</a>.</p><div class="eb-speedy-notice-actions"><button type="button" data-speedy-cancel>Cancel</button><button type="button" data-speedy-yes>Yes, continue</button></div>';
      document.body.appendChild(speedyNotice);
      speedyNotice.querySelector('[data-speedy-cancel]').addEventListener('click', function () { speedyNotice.close(); });
      speedyNotice.querySelector('.eb-speedy-close').addEventListener('click', function () { speedyNotice.close(); });
      speedyNotice.querySelector('[data-speedy-yes]').addEventListener('click', function () {
        speedyNotice.close();
        if (currentVariant().available) openPanel(true);
      });
    }
    if (!speedyNotice.open) speedyNotice.showModal();
  }
  function openPanel(speedyAccepted) {
    if (!panel || panel.getAttribute('data-open') === '1') return;
    if ((CFG.frame.handle === 'speedy' || CFG.frame.handle === 'zoom') && speedyAccepted !== true) { showSpeedyNotice(); return; }
    if (!renderedOnce) render();
    if (window.EyeBuddyRxOcr && window.EyeBuddyRxOcr.prewarm) window.EyeBuddyRxOcr.prewarm();
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    lastFocus = document.activeElement; scrim.hidden = false; panel.hidden = false;
    document.documentElement.classList.add('eb-scroll-lock'); document.body.classList.add('eb-scroll-lock');
    void panel.offsetWidth;
    scrim.classList.add('eb-rxflow-scrim--open'); panel.classList.add('eb-rxflow-panel--open'); panel.setAttribute('data-open', '1');
    keyHandler = onPanelKey; document.addEventListener('keydown', keyHandler, true);
    if (closeBtn) closeBtn.focus();
  }
  function closePanel() {
    if (!panel || panel.getAttribute('data-open') !== '1') return;
    scrim.classList.remove('eb-rxflow-scrim--open'); panel.classList.remove('eb-rxflow-panel--open');
    document.documentElement.classList.remove('eb-scroll-lock'); document.body.classList.remove('eb-scroll-lock');
    panel.removeAttribute('data-open');
    if (keyHandler) { document.removeEventListener('keydown', keyHandler, true); keyHandler = null; }
    var hide = function () { panel.hidden = true; scrim.hidden = true; };
    if (reduceMotion) hide(); else hideTimer = setTimeout(hide, 340);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.eb-select')) closeSelectMenus();
    var t = e.target.closest && e.target.closest('[data-eb-rx-open]');
    if (t) {
      e.preventDefault();
      if (t.disabled || t.getAttribute('aria-disabled') === 'true' || !currentVariant().available) return;
      openPanel();
    }
  });
  if (scrim) scrim.addEventListener('click', closePanel);
  if (closeBtn) closeBtn.addEventListener('click', closePanel);

  var lastVid = null;
  setInterval(function () {
    var v = currentVariant();
    if (v.id !== lastVid) {
      lastVid = v.id; syncRxTriggers(v); syncFrameVariantInput(v);
      if (renderedOnce) syncSummary();
      if (cur() === 'review' && !state.added) render();
    }
  }, 1500);

  document.body.classList.add('eb-rxflow-active');
  syncRxTriggers(currentVariant());
  syncFrameVariantInput(currentVariant());
})();
